import SupplierEligibilityDialog from "./SupplierEligibilityDialog";
import { rctiCurrencyCode } from "utils/rctiCurrency";
import { contactAddress } from "utils/contactAddress";
import {
  rctiToday,
  rctiCalendarDate,
  rctiEarliestSupplyDate,
  validateRctiSupplyDate,
} from "utils/rctiDates";
import { calculateRctiPricing } from "utils/rctiPricing";
import { rctiTimestamp } from "utils/rctiTimestamp";
import { isSignedAgreement } from "utils/rctiAgreementSigned";
import {
  rctiAttachmentUrl,
  downloadRctiAttachment,
} from "utils/rctiAttachmentAPI";
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */

import { ClearableSearchInput } from "components/SearchField/SearchField";
import PickDate from "components/DatePicker/DatePicker";
import CatalogueItemModal from "components/CatalogueItemModal";
import CatalogueItemDropdown from "components/CatalogueItemDropdown";
import useLineItemReorder from "hooks/useLineItemReorder";
import useDraftDocumentState from "hooks/useDraftDocumentState";
import useUnsavedChanges from "hooks/useUnsavedChanges";
import useUnsavedModalChanges from "hooks/useUnsavedModalChanges";
import useBillingDocumentNumber from "hooks/useBillingDocumentNumber";
import { clearBillingNumberPreview } from "utils/billingNumberPreview";
import useDocumentNumberValidation from "hooks/useDocumentNumberValidation";
import { showDraftSavedMessage } from "components/InlineFeedback/DraftSaveConfirmation";
import axios from "axios";
import validator from "validator";
import PageSkeleton from "components/Skeleton/PageSkeleton";
import { verifiedSupplierChoices } from "utils/supplierSelection";
import Skeleton from "components/Skeleton";
import ShowSwalWithButtons from "components/SwalAlert/swalPopupWithButtons";
import BillingModal from "components/displayModel/billingModel";
import { useMaterialUIController } from "context";
import { format } from "date-fns";
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import swal from "sweetalert";
import Swal from "sweetalert2";
import { addCatalogueItemData, getCurrencyCode } from "utils/api";
import { appConstants } from "utils/appConstants";
import { getFileType } from "utils/generic";
import {
  convertToTitleCase,
  getScreenRight,
  showResMsg,
  validateField,
} from "utils/generic";
import { genericMessage } from "utils/genericMessages";
import {
  SaveRCTI,
  UpdateRCTI,
  downloadRCTI,
  getItemsForInvoice,
  getRCTIDetailsByID,
  getSupplierForRCTI,
} from "utils/invoiceAPI";
import { useCatalogueAccountOptions } from "utils/catalogueAccounts";
import { getEmailAndTemplateForQuotation } from "utils/quotationAPI";
import { AllKeysHaveValue } from "utils/generic";
import { calculateAmounts } from "utils/generic";
import { formatCurrencyAUD } from "utils/formatCurrency";
import { sanitizeQuantityInputValue } from "utils/numberInputConstraints";
import {
  createPendingAttachment,
  uploadPendingAttachments,
} from "utils/documentAttachments";

import RouteModal from "components/displayModel/routeModal";
import { formatNumberWithCommas } from "utils/formatCurrency";
import { savePdfResponse } from "utils/documentPdf";
import {
  LuArrowLeft,
  LuCalendar,
  LuCheck,
  LuChevronDown,
  LuCircleAlert,
  LuEye,
  LuFileText,
  LuGripVertical,
  LuPlus,
  LuSearch,
  LuSend,
  LuTrash2,
  LuUpload,
  LuX,
} from "react-icons/lu";
import AppHeader from "components/AppHeader";
import { DashboardNavigation } from "layouts/businessUserDashboard";
import DebitNoteResponsiveHeader from "layouts/DebitNote/DebitNoteResponsiveHeader";
import { agreementRequest } from "utils/rctiAgreementAPI";
import { formatAbn } from "utils/abn";
import { RctiSteps, rctiSteps } from "./RctiDesignSystem";
import RCTIAdjustmentComparison from "./RCTIAdjustmentComparison";
import RCTIIssueCommunications from "./RCTIIssueCommunications";
import RCTIDocument from "./RCTIDocument";
import InvoiceSelect from "components/FormControls/ThemedSelect";
import "layouts/Invoices/invoiceFlow.css";
import "layouts/Quotation/quotation.css";
import "./rctiEditor.css";
import "./rctiPrepare.css";
import "./rctiResponsive.css";

const errMsg = {
  color: `red`,
  fontSize: `11px`,
};

const SCREEN_NAME = "RCTI";
const MAX_VISIBLE_ITEM_ROWS = 4;
const hasItemIdentity = (row) =>
  Boolean(
    String(row.itemName || "").trim() ||
      String(row.itemDescription || "").trim()
  );
const hasItemContent = (row) =>
  Boolean(
    row.itemID || hasItemIdentity(row) || String(row.itemPrice ?? "").trim()
  );
let SCREEN_RIGHT;
const EMPTY_ITEM_ROW = {
  itemID: "",
  itemName: "",
  itemPrice: "",
  itemDescription: "",
  categoryCodeName: "Sales",
  itemQuantity: 1,
  gst: 10,
  discountType: "None",
  discountValue: "",
  discountAmount: 0,
  totalItemPrice: 0,
};

export async function handleApiResponse({
  isUpdate,
  values,
  setOpen,
  showResMsg,
  navigate,
  handleSoftDismisal,
  setShowBillingModal,
  dispatch,
  redirectToOutside,
  RCTI_ID,
  setCommunicationPhase,
  setCommunicationError = () => {},
  setValues,
  settlementReturn,
  saveAttachments,
  onSaved,
  onDraftSaved,
  onNumberError,
}) {
  const issuingRequested = Boolean(values.sendEmailFlag);
  if (issuingRequested) setCommunicationError("");
  // Creation and delivery are separate API operations. Keep the new ID before
  // uploading or sending so either failure can be retried without another RCTI.
  if (
    issuingRequested &&
    (!isUpdate || values.issuedAt || Number(values.emailSent) > 0)
  ) {
    setCommunicationPhase("issuing");
    let created;
    await (isUpdate ? UpdateRCTI : SaveRCTI)(
      { ...values, sendEmailFlag: false },
      (data) => {
        created = data;
      },
      dispatch,
      (data) => {
        created = data;
      },
      { showLoader: false }
    );
    if (!created?.Result_Status) {
      if (onNumberError?.(created)) return;
      setCommunicationError(
        created?.Result_Message || "The RCTI could not be created."
      );
      setCommunicationPhase("failed");
      setValues((current) => ({ ...current, sendEmailFlag: false }));
      showResMsg(
        created?.Result_Message || "The RCTI could not be created.",
        2400,
        false
      );
      return;
    }
    clearBillingNumberPreview("rcti", values.businessUserID);
    Object.assign(values, created.Result_Output, {
      rctiID: created.Result_Output._id,
      rctiNumber: created.Result_Output.rctiNumber || values.rctiNumber,
      issuedAt: null,
      emailSent: 0,
      sendEmailFlag: issuingRequested,
      expectedVersion: created.Result_Output.version || 1,
    });
    setValues((current) => ({ ...current, ...values }));
    isUpdate = true;
  }
  if (
    issuingRequested &&
    !(await saveAttachments(values.rctiID || RCTI_ID))
  ) {
    setCommunicationError(
      "The attachments could not be saved. Please retry uploading them before sending."
    );
    setCommunicationPhase("failed");
    setValues((current) => ({ ...current, sendEmailFlag: false }));
    return;
  }
  const apiFunction = isUpdate ? UpdateRCTI : SaveRCTI;
  if (issuingRequested) setCommunicationPhase("issuing");
  return apiFunction(
    values,
    async (data) => {
      if (data?.Result_Status) {
        if (issuingRequested) setOpen(false);
        clearBillingNumberPreview("rcti", values.businessUserID);
        const targetId = data.Result_Output?._id || RCTI_ID || values.rctiID;
        values.rctiID = targetId;
        values.rctiNumber = data.Result_Output?.rctiNumber || values.rctiNumber;
        setValues((current) => ({
          ...current,
          ...data.Result_Output,
          rctiID: targetId,
          rctiNumber: data.Result_Output?.rctiNumber || current.rctiNumber,
        }));
        if (!issuingRequested && !(await saveAttachments(targetId))) {
          if (issuingRequested) setCommunicationPhase("failed");
          return;
        }
        onSaved?.({ ...values, ...data.Result_Output, rctiID: targetId });
        if (redirectToOutside === "downloadDraft") {
          await onDraftSaved?.({
            ...values,
            ...data.Result_Output,
            _id: targetId,
            rctiID: targetId,
          });
          return;
        }
        if (settlementReturn) {
          navigate(`/rcti/view/${RCTI_ID}`, {
            state: { paymentRecorded: { amount: values.paymentAmount } },
          });
          return;
        }
        if (issuingRequested) {
          setCommunicationPhase("sent");
          if (data.Result_Output && typeof data.Result_Output === "object") {
            setValues((current) => ({
              ...current,
              ...data.Result_Output,
              sendEmailFlag: false,
              adjustmentReason: "",
            }));
          }
          showDraftSavedMessage("RCTI sent successfully");
          if (targetId) {
            setOpen(false);
            navigate(`/rcti/view/${targetId}`, { replace: true, state: { rctiIssued: true } });
          }
          return;
        }
        setOpen(false);
        // showResMsg(data.Result_Message, 2000, data.Result_Status,);
        let targetRoute;
        if (redirectToOutside === "redirectToItemWhenSave") {
          navigate(`/items/addItems?new=rcti&id=${data.Result_Output._id}`);
        } else if (redirectToOutside === "redirectToEditItemWhenSave") {
          let ItemIdForItemEdit = sessionStorage.getItem("ItemIdForItemEdit");
          console.log("ItemIdForItemEdit", ItemIdForItemEdit);
          sessionStorage.removeItem("ItemIdForItemEdit");
          navigate(
            `/items/editItem/itemid=${ItemIdForItemEdit}?source=rcti&id=${
              data.Result_Output._id || ""
            }`
          );
        } else {
          showDraftSavedMessage(
            values.issuedAt || Number(values.emailSent) > 0
              ? data.Result_Message || "Adjustment saved successfully."
              : undefined
          );
          if (redirectToOutside === "leaveAfterSave") navigate("/rcti");
          else if (!["saveAndExit", "saveAndLeave"].includes(redirectToOutside) && !RCTI_ID && targetId)
            navigate(`/rcti/edit/${targetId}`, { replace: true });
          // let targetRoute = '/rcti';
          // let targetRoute = `/rcti/edit/${data.Result_Output._id}`;
          // navigate(targetRoute);
        }
        // if (isUpdate) {
        //   // targetRoute = (data.Result_Output?.redirect) ? '/rcti' : '';
        //   targetRoute = '/rcti';

        // } else {
        //   //when save api run below code will excute
        //   targetRoute = '/rcti/edit/' + data.Result_Output._id;

        // }
        // navigate(targetRoute);
      } else if (onNumberError?.(data)) {
        return;
      } else if (settlementReturn) {
        const message =
          data?.Result_Message ||
          "The payment was not recorded. No payable balance was changed.";
        navigate(`/rcti/view/${RCTI_ID}`, {
          state: {
            paymentError: {
              message,
              draft: {
                amount: values.paymentAmount,
                method: values.paymentMode,
                reference: values.paymentTransactionID,
                paymentDate: values.paymentDate,
              },
            },
          },
        });
      } else if (data.Result_Message === "ALREADY_EXIST_PO") {
        if (issuingRequested) {
          setCommunicationPhase("failed");
          setValues((current) => ({ ...current, sendEmailFlag: false }));
        }
        handleSoftDismisal();
      } else {
        if (issuingRequested) {
          setCommunicationError(
            data.Result_Message || "The RCTI could not be issued."
          );
          setCommunicationPhase("failed");
          setValues((current) => ({ ...current, sendEmailFlag: false }));
        }
        if (data.Result_Output === "NO AVAILABLE CREDITS") {
          setShowBillingModal(true);
        }
        showResMsg(data.Result_Message, 2000, data.Result_Status);
      }
    },
    dispatch,
    (error) => {
      if (onNumberError?.(error)) return;
      const message =
        error?.Result_Message ||
        "The RCTI could not be saved. No payment was recorded.";
      if (settlementReturn)
        navigate(`/rcti/view/${RCTI_ID}`, {
          state: {
            paymentError: {
              message,
              draft: {
                amount: values.paymentAmount,
                method: values.paymentMode,
                reference: values.paymentTransactionID,
                paymentDate: values.paymentDate,
              },
            },
          },
        });
      else {
        if (issuingRequested) {
          setCommunicationError(message);
          setCommunicationPhase("failed");
          setValues((current) => ({ ...current, sendEmailFlag: false }));
        }
        showResMsg(message, 2400, false);
      }
    },
    { showLoader: false }
  );
}

function RCTI() {
  let navigate = useNavigate();
  const location = useLocation();
  let dispatch = useDispatch();
  const { id: RCTI_ID } = useParams();
  const [supplierEligibilityOpen, setSupplierEligibilityOpen] = useState(false);
  let type = new URLSearchParams(window.location.search).get("type");
  const [viewDocumentInModal, setViewDocumentInModal] = useState(false);
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const [loginDetails, setLoginDetails] = useState(
    JSON.parse(sessionStorage.getItem("LOGIN_DETAILS"))
  );
  const catalogueAccountOptions = useCatalogueAccountOptions(
    loginDetails?.businessUserID
  );
  const [token, setToken] = useState(sessionStorage.getItem("TOKEN"));
  const [invoiceNoErr, setInvoiceNoErr] = useState(false);
  const numberValidation = useDocumentNumberValidation(
    "rcti",
    "rcti-number-input"
  );
  const [contactNameErr, setContactNameErr] = useState(false);
  const [
    supplierEmailValidationAttempted,
    setSupplierEmailValidationAttempted,
  ] = useState(false);
  const [loading, setLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);
  const [editorLoadError, setEditorLoadError] = useState("");
  const [loadAttempt, setLoadAttempt] = useState(0);
  const [draftPreviewOpen, setDraftPreviewOpen] = useState(false);
  const [draftPreviewBounds, setDraftPreviewBounds] = useState(null);
  const [downloadingDraft, setDownloadingDraft] = useState(false);
  const draftSaveRef = useRef(false);
  const draftPreviewAnchorRef = useRef(null);
  const [adjustmentOriginal, setAdjustmentOriginal] = useState(null);
  const [agreementData, setAgreementData] = useState(null);
  const [buyerDeclarationConfirmation, setBuyerDeclarationConfirmation] = useState(null);
  useLayoutEffect(() => {
    if (!draftPreviewOpen) return undefined;
    const main = draftPreviewAnchorRef.current?.querySelector(
      ".invoice-flow-main"
    );
    if (!main) return undefined;
    const measure = () => {
      const rect = main.getBoundingClientRect();
      setDraftPreviewBounds(
        rect.width ? { left: rect.left, width: rect.width } : null
      );
    };
    measure();
    const observer =
      typeof ResizeObserver !== "undefined"
        ? new ResizeObserver(measure)
        : null;
    observer?.observe(main);
    window.addEventListener("resize", measure);
    return () => {
      observer?.disconnect();
      window.removeEventListener("resize", measure);
    };
  }, [draftPreviewOpen]);
  useEffect(() => {
    let mounted = true;
    agreementRequest("", undefined, "get")
      .then((data) => {
        if (mounted) setAgreementData(data);
      })
      .catch(() => {});
    return () => {
      mounted = false;
    };
  }, []);
  const [contactDetails, setContactDetails] = useState([]);
  const [showInvoicePaymentLink, setShowInvoicePaymentLink] = useState(false);
  const [masterItemDetails, setMasterItemDetails] = useState([]);
  const [navOpen, setNavOpen] = useState(false);
  const [hasEditedRCTI, setHasEditedRCTI] = useState(false);
  const [activeItemDropdownIdx, setActiveItemDropdownIdx] = useState(null);
  const [itemSearchQueries, setItemSearchQueries] = useState({});
  const [isItemModalOpen, setIsItemModalOpen] = useState(false);
  const [isItemSaving, setIsItemSaving] = useState(false);
  const [itemModalError, setItemModalError] = useState("");
  const [itemModalTargetIdx, setItemModalTargetIdx] = useState(null);
  const [newItemForm, setNewItemForm] = useState({
    itemName: "",
    itemCode: "",
    itemDescription: "",
    itemPrice: "",
    categoryCodeName: "200 - Sales",
    status: "Active",
    unit: "each",
    defaultQuantity: 1,
    gst: 10,
    discountType: "None",
    discountValue: "",
  });
  const itemModalChanges = useUnsavedModalChanges({
    open: isItemModalOpen,
    values: newItemForm,
    busy: isItemSaving,
    onClose: () => {
      setIsItemModalOpen(false);
      setItemModalTargetIdx(null);
    },
  });
  const itemDropdownRefs = useRef([]);
  const [showBillingModal, setShowBillingModal] = useState(false);
  const [getDocumentFileURL, setSetDocumentFileURL] = useState("");
  const [selectedFileType, setSelectedFileType] = useState("");
  const [fileError, setFileError] = useState("");
  const [fieldsVisible, setFieldsVisible] = useState(false);
  const [openPop, setOpenPop] = useState(false);
  const [itemRowValues, setItemRowValues] = useState([{ ...EMPTY_ITEM_ROW }]);
  const [itemsViewportHeight, setItemsViewportHeight] = useState(null);
  const itemsTableBodyRef = useRef(null);
  const pendingItemsScrollRef = useRef(null);
  //Used for Modal Email Template
  const [open, setOpen] = useState(false);
  const [communicationPhase, setCommunicationPhase] = useState("review");
  const [communicationError, setCommunicationError] = useState("");
  const communicationStartStepRef = useRef(1);
  const [templateValues, setTemplateValues] = useState({
    screenType: "RCTI",
    userEmailAddress: "",
    customerEmailAddress: [],
    emailTemplate: "",
  });
  const [values, setValues] = useState({
    token: token,
    businessUserID: loginDetails?.businessUserID,
    userID: loginDetails?._id,
    rctiID: undefined,
    rctiNumber: "",
    rctiNumberEdited: false,
    supplierID: "",
    purchaseOrderNumber: "",
    rctiDate: rctiToday(),
    supplyDate: rctiToday(),
    originalSupplyDate: "",
    dueDate: null,
    dueUpto: "",
    rctiStatus: "Unpaid",
    gstType: "Inclusive",
    totalAmount: 0,
    totalDiscountAmount: 0,
    totalGSTAmount: 0,
    finalAmount: 0,
    paymentInstruction: "",
    supplierNotes: "",
    rctiNotes: "",
    documentName: "",

    paymentDate: new Date(),
    paymentMode: undefined,
    paymentTransactionID: undefined,
    paymentAmount: undefined,
    sendEmailFlag: false,
  });
  const [quoDocuments, setDocuments] = useState([]);
  const rctiNumber = useBillingDocumentNumber({
    type: "rcti",
    documentID: RCTI_ID || values.rctiID,
    businessUserID: loginDetails?.businessUserID,
    setValues,
  });
  const draftDocument = useDraftDocumentState({
    type: "rcti",
    id: RCTI_ID || values.rctiID,
    values,
    items: itemRowValues,
    documents: quoDocuments,
    saving: loading,
  });
  const hasUnsavedContent = Boolean(
    Number(Boolean(hasEditedRCTI)) +
      Number(Boolean(values.supplierID)) +
      Number(itemRowValues.some(hasItemContent)) +
      Number(quoDocuments.some((document) => document.file))
  );
  const shouldGuardUnsavedChanges = Boolean(
    Number(Boolean(draftDocument.hasUnsavedChanges)) *
      Number(hasUnsavedContent)
  );
  const saveAndExitRef = useRef(null);
  const unsavedChanges = useUnsavedChanges(shouldGuardUnsavedChanges, {
    documentName: "RCTI",
    isExistingDraft: Boolean(RCTI_ID || values.rctiID),
    canSaveDraft:
      Boolean(
        adjustmentOriginal ||
          (!values.issuedAt && !Number(values.emailSent))
      ) && !location.state?.paymentFlowReturn,
    onSave: () => handleSaveRCTI("saveAndLeave"),
  });
  const [currencyCode, setCurrencyCode] = useState("");
  const [paymentModeErr, setPaymentModeErr] = useState(false);
  const [paymentTransactionIDErr, setPaymentTransactionIDErr] = useState(false);
  const [showSaveAndSendEmailBtn, setShowSaveAndSendEmailBtn] = useState(true);
  const [showSendEmailBtn, setShowSendEmailBtn] = useState(false);

  const itemRowValuesRef = useRef(itemRowValues);
  const itemReorder = useLineItemReorder({
    rows: itemRowValues,
    setRows: setItemRowValues,
    setSearchQueries: setItemSearchQueries,
    closeSearch: () => setActiveItemDropdownIdx(null),
    disabled: loading || values.rctiStatus === "Paid",
    idPrefix: "rcti",
    darkMode,
  });

  useLayoutEffect(() => {
    const tableBody = itemsTableBodyRef.current;
    if (!tableBody || itemRowValues.length < MAX_VISIBLE_ITEM_ROWS) {
      setItemsViewportHeight(null);
      return undefined;
    }
    const visibleRows = Array.from(tableBody.children).slice(
      0,
      MAX_VISIBLE_ITEM_ROWS
    );
    const updateViewportHeight = () => {
      const height = visibleRows.reduce(
        (total, row) => total + row.getBoundingClientRect().height,
        0
      );
      if (height > 0) setItemsViewportHeight(Math.ceil(height));
    };
    updateViewportHeight();
    window.addEventListener("resize", updateViewportHeight);
    const resizeObserver =
      typeof ResizeObserver !== "undefined"
        ? new ResizeObserver(updateViewportHeight)
        : null;
    visibleRows.forEach((row) => resizeObserver?.observe(row));
    return () => {
      window.removeEventListener("resize", updateViewportHeight);
      resizeObserver?.disconnect();
    };
  }, [itemRowValues.length]);

  useLayoutEffect(() => {
    const tableBody = itemsTableBodyRef.current;
    if (!tableBody || !pendingItemsScrollRef.current) return undefined;
    pendingItemsScrollRef.current = null;
    const animationFrame = window.requestAnimationFrame(() => {
      if (typeof tableBody.scrollTo === "function") {
        tableBody.scrollTo({
          top: tableBody.scrollHeight,
          behavior: window.matchMedia?.("(prefers-reduced-motion: reduce)")
            .matches
            ? "auto"
            : "smooth",
        });
      } else {
        tableBody.scrollTop = tableBody.scrollHeight;
      }
    });
    return () => window.cancelAnimationFrame(animationFrame);
  }, [itemRowValues.length]);

  useEffect(() => {
    let HoldQuotationData = JSON.parse(
      sessionStorage.getItem("HoldQuotationData")
    );
    console.log("HoldQuotationData", HoldQuotationData);

    if (HoldQuotationData) {
      setValues((prevValues) => ({
        ...prevValues,

        businessUserID: HoldQuotationData.businessUserID || "",
        supplierID: HoldQuotationData.supplierID || "",
        rctiDate: rctiToday(),
        supplyDate: rctiCalendarDate(HoldQuotationData.supplyDate),
        originalSupplyDate: rctiCalendarDate(
          HoldQuotationData.originalSupplyDate
        ),
        createdDate: HoldQuotationData.createdDate,
        issuedAt: HoldQuotationData.issuedAt,
        dueUpto: "",
        dueDate: null,
        // quotationNumber: HoldQuotationData.quotationNumber || "",
        finalAmount: HoldQuotationData.finalAmount || "0.00",
        totalAmount: HoldQuotationData.totalAmount || "0.00",
        totalDiscountAmount: HoldQuotationData.totalDiscountAmount || "0.00",
        totalGSTAmount: HoldQuotationData.totalGSTAmount || "0.00",
        name: HoldQuotationData.name || "",
        gstType: HoldQuotationData.gstType || "Inclusive",
        rctiStatus: HoldQuotationData.rctiStatus || "Pending",
        purchaseOrderNumber: HoldQuotationData.purchaseOrderNumber || "",
        paymentInstruction: HoldQuotationData.paymentInstruction || "",
      }));
    }

    if (
      JSON.stringify(itemRowValues) !== JSON.stringify(itemRowValuesRef.current)
    ) {
      itemRowValuesRef.current = itemRowValues;
      calculateDiscountAmount(itemRowValues);
    }
    const filtered = itemRowValues.filter(hasItemContent);
    if (filtered.length > 0) {
      setShowSendEmailBtn(
        filtered.every(
          (row) => hasItemIdentity(row) && row.itemPrice && row.itemQuantity
        )
      );
    } else {
      setShowSendEmailBtn(false);
    }
  }, [itemRowValues]);

  useEffect(() => {
    let current = true;
    const fetchData = async () => {
      setInitialLoading(true);
      setEditorLoadError("");
      try {
        setLoginDetails(JSON.parse(sessionStorage.getItem("LOGIN_DETAILS")));

        await Promise.all([
          getRight(),
          LoadInitialData(),
          fetchCurrencyValue(),
          FetchQuotationDetailsByID(),
        ]);
      } catch (error) {
        if (current) setEditorLoadError("Could not load the RCTI editor. Please retry.");
      } finally {
        if (current) setInitialLoading(false);
      }
    };
    fetchData();
    return () => { current = false; };
  }, [dispatch, RCTI_ID, loadAttempt]);

  useEffect(() => {
    if (location.state?.openPaymentDetails && RCTI_ID) {
      setShowInvoicePaymentLink(true);
      setFieldsVisible(true);
    }
  }, [location.state, RCTI_ID]);

  useEffect(() => {
    const isItemSelected = itemRowValues.every(
      (row) => hasItemIdentity(row) && row.itemPrice && row.itemQuantity
    );
    setShowSaveAndSendEmailBtn(!isItemSelected);
  }, [itemRowValues]);

  async function getRight() {
    SCREEN_RIGHT = await getScreenRight(SCREEN_NAME);
    if (SCREEN_RIGHT !== "Full Access") {
      showResMsg(genericMessage.notPermission, 2000, false);
      navigate("/rcti");
    }
  }
  const LoadInitialData = async () => {
    return getSupplierForRCTI(
      values,
      (data) => {
        setContactDetails(
          data.Result_Status && Array.isArray(data.Result_Output)
            ? verifiedSupplierChoices(data.Result_Output)
            : []
        );
      },
      dispatch
    );
  };
  let fetchCurrencyValue = async () => {
    await getCurrencyCode(
      { businessUserID: values.businessUserID },
      (data) => {
        if (data.Result_Status) {
          setCurrencyCode(data.Result_Output);
        }
      },
      dispatch
    );
  };

  const FetchQuotationDetailsByID = async () => {
    try {
      // Fetch items for quotation
      const itemsPromise = new Promise((resolve, reject) => {
        Promise.resolve(getItemsForInvoice(
          values,
          (data) => {
            if (data.Result_Output.length > 0) {
              setMasterItemDetails(data.Result_Output);
              resolve();
            } else {
              reject(new Error("No items found for quotation"));
            }
          },
          dispatch
        )).then(resolve, reject);
      });
      let detailsPromise;
      const cloneSourceID = !RCTI_ID ? new URLSearchParams(location.search).get("cloneFrom") : null;
      if (RCTI_ID || cloneSourceID) {
        const detailsRequest = { ...values, rctiID: RCTI_ID || cloneSourceID };
        // Fetch the owned source without treating a copied document as an edit.
        detailsPromise = new Promise((resolve, reject) => {
          let detailsReceived = false;
          Promise.resolve(getRCTIDetailsByID(
            detailsRequest,
            (data) => {
              let result = data?.Result_Output?.[0];
              if (result) {
                detailsReceived = true;
                const loadedItems = calculateRctiPricing(
                  result.items || [],
                  result.gstType || values.gstType
                ).items;
                if (cloneSourceID) {
                  const copied = {};
                  for (const key of ["gstType", "currencyValue", "currencyID", "totalAmount", "finalAmount", "totalDiscountAmount", "totalGSTAmount", "notes", "additionalNote"]) {
                    if (result[key] !== undefined) copied[key] = result[key];
                  }
                  setValues((current) => ({ ...current, ...copied, supplierID: String(result.supplierID?._id || result.supplierID || ""), rctiDate: rctiToday(), supplyDate: rctiToday(), dueDate: null, dueUpto: "" }));
                  setItemRowValues(loadedItems.map(({ _id, rctiID, ...item }) => item));
                  resolve();
                  return;
                }
                if (result.issuedAt || Number(result.emailSent) > 0)
                  setAdjustmentOriginal({ ...result });
                else if (result.versions?.length)
                  setAdjustmentOriginal(
                    result.versions[result.versions.length - 1].document
                  );
                const loadedValues = {
                  ...values,
                  ...result,
                  rctiDate: rctiToday(),
                  supplyDate: rctiCalendarDate(result.supplyDate),
                  originalSupplyDate: rctiCalendarDate(result.supplyDate),
                  adjustmentReason: result.issuedAt || Number(result.emailSent) > 0
                    ? "" : result.adjustmentReason || "",
                  ...(location.state?.settlementDraft
                    ? {
                        paymentMode: location.state.settlementDraft.method,
                        paymentTransactionID:
                          location.state.settlementDraft.reference,
                        paymentDate: location.state.settlementDraft.paymentDate,
                      }
                    : {}),
                };
                draftDocument.markSaved(loadedValues, loadedItems);
                setValues(loadedValues);
                if (loadedItems.length > 0) {
                  setItemRowValues(loadedItems);
                }
                if (result.documents?.length > 0) {
                  setDocuments(result.documents);
                }

                // setShowItemAndDocumentSection(true);
                setShowInvoicePaymentLink(
                  Boolean(
                    location.state?.openPaymentDetails ||
                      data.Result_Output[0].showPaymentSection
                  )
                );
                if (location.state?.openPaymentDetails) setFieldsVisible(true);
                resolve(); // Resolve the promise once data is fetched
              } else {
                reject(new Error("No RCTI details found"));
              }
            },
            dispatch
          )).then(() => {
            if (!detailsReceived) reject(new Error("No RCTI details found"));
            else resolve();
          }, reject);
        });
      }
      // Wait for both promises to resolve
      const results = await Promise.allSettled([itemsPromise, detailsPromise]);
      if (results[1].status === "rejected") throw results[1].reason;
    } catch (error) {
      setEditorLoadError("Could not load the saved RCTI. Please retry.");
    }
  };

  const handleChange = (name) => (event) => {
    setHasEditedRCTI(true);
    let value = event?.target?.value;
    if (name === "gstType") {
      handleCalculation(value);
    } else if (name === "supplierID" && value === "add_new") {
      navigate("/contacts/addContact?new=rcti");
    } else if (event.target.validity && event.target.validity.valid) {
      setValues({ ...values, [name]: value });
    } else if (event.target.validity === undefined) {
      setValues({ ...values, [name]: value });
    }
  };
  const handleChangeCustomer = (name) => (event, newValue) => {
    let value = event?.target?.value;

    console.log("sadasdasda", {
      [name]: newValue?.label,
      supplierID: newValue?.value,
    });
    if (newValue) {
      if (newValue.value === "add-new") {
        navigate("/contacts/addContact?new=rcti");
      } else {
        setValues({
          ...values,
          [name]: newValue?.label,
          supplierID: newValue?.value,
        });
      }
    } else {
      setValues({ ...values, [name]: "", supplierID: "" });
    }
  };

  const resetNewItemForm = (itemName = "") => {
    setNewItemForm({
      itemName,
      itemCode: "",
      itemDescription: "",
      itemPrice: "",
      categoryCodeName: "200 - Sales",
      status: "Active",
      unit: "each",
      defaultQuantity: 1,
      gst: 10,
      discountType: "None",
      discountValue: "",
    });
  };

  const handleAddNewItem = () => {
    setActiveItemDropdownIdx(null);
    setItemModalTargetIdx(null);
    setItemModalError("");
    resetNewItemForm();
    setIsItemModalOpen(true);
  };

  const handleQuickCreateItem = async () => {
    if (isItemSaving) return;
    if (!newItemForm.itemCode.trim()) {
      setItemModalError("itemCode");
      return;
    }
    if (!newItemForm.itemName.trim()) {
      setItemModalError("itemName");
      return;
    }
    if (newItemForm.itemPrice === "") {
      setItemModalError("itemPrice");
      return;
    }
    setItemModalError("");
    setIsItemSaving(true);
    await addCatalogueItemData(
      {
        businessUserID: loginDetails?.businessUserID,
        itemName: newItemForm.itemName.trim(),
        itemCode: newItemForm.itemCode.trim(),
        itemDescription: newItemForm.itemDescription.trim(),
        itemPrice: parseFloat(newItemForm.itemPrice) || 0,
        itemQuantity: parseFloat(newItemForm.defaultQuantity) || 1,
        categoryCodeName: newItemForm.categoryCodeName,
        categoryName: newItemForm.categoryCodeName,
        gst: Number(newItemForm.gst),
        itemStatus: newItemForm.status,
        unit: newItemForm.unit,
        discountType: newItemForm.discountType,
        discountValue: parseFloat(newItemForm.discountValue) || 0,
        source: "rcti",
      },
      (data) => {
        if (!data?.Result_Status || !data.Result_Output) {
          const message =
            data?.Result_Message || "Failed to create catalogue item.";
          setItemModalError(message);
          showResMsg(message, 2000, false);
          return;
        }
        const created = data.Result_Output;
        setMasterItemDetails((previous) => [created, ...previous]);
        const itemPrice = Number(created.itemPrice) || 0;
        const itemQuantity = Number(created.itemQuantity) || 1;
        const discountValue = Number(created.discountValue) || 0;
        const discountAmount =
          created.discountType === "Percentage"
            ? (itemPrice * itemQuantity * discountValue) / 100
            : created.discountType === "Fixed"
            ? discountValue
            : 0;
        const createdRow = {
          itemID: created._id,
          itemName: created.itemName,
          itemDescription: created.itemDescription || "",
          categoryCodeName: created.categoryCodeName,
          itemPrice,
          itemQuantity,
          gst: created.gst,
          discountType: created.discountType || "None",
          discountValue,
          discountAmount,
          totalItemPrice: (itemPrice * itemQuantity).toFixed(2),
        };
        if (itemModalTargetIdx !== null) {
          handleSelectCatalogueItem(itemModalTargetIdx, created);
        } else {
          setItemRowValues((previous) => {
            const emptyIndex = previous.findIndex(
              (row) => !hasItemContent(row)
            );
            if (emptyIndex === -1) return [...previous, createdRow];
            return previous.map((row, index) =>
              index === emptyIndex ? createdRow : row
            );
          });
          setItemSearchQueries({});
        }
        setItemModalTargetIdx(null);
        setIsItemModalOpen(false);
        resetNewItemForm();
        showDraftSavedMessage("Catalogue item created successfully");
      },
      dispatch,
      { showLoader: false }
    );
    setIsItemSaving(false);
  };
  const clearAllErrorMsg = () => {
    setContactNameErr(false);
    setInvoiceNoErr(false);
  };

  function identifyMissingItems(itemRowValues) {
    let missingItems = [];
    itemRowValues.forEach((row, index) => {
      if (!hasItemIdentity(row) || !row.itemPrice || !row.itemQuantity) {
        missingItems.push(index + 1);
      }
    });

    if (missingItems.length === 0) {
      return "All items are filled in.";
    }

    let missingItemsMessage =
      "Please fill in all of the following items before creating the rcti:\n";
    missingItems.forEach((itemIndex) => {
      missingItemsMessage += `Row ${itemIndex}: `;
      if (!hasItemIdentity(itemRowValues[itemIndex - 1])) {
        missingItemsMessage += "Item name or description, ";
      }
      if (!itemRowValues[itemIndex - 1].itemPrice) {
        missingItemsMessage += "Item Price, ";
      }
      if (!itemRowValues[itemIndex - 1].itemQuantity) {
        missingItemsMessage += "Item Quantity, ";
      }
      missingItemsMessage = missingItemsMessage.slice(0, -2);
      missingItemsMessage += "\n";
    });

    return missingItemsMessage;
  }

  const downloadDraftPdf = async (
    documentId,
    documentNumber = values.rctiNumber
  ) => {
    if (!documentId || downloadingDraft) return;
    setDownloadingDraft(true);
    try {
      await downloadRCTI(
        { _id: documentId },
        (response) =>
          savePdfResponse(
            response,
            `${documentNumber || "RCTI-draft"}.pdf`
          ),
        dispatch
      );
    } finally {
      setDownloadingDraft(false);
    }
  };

  const handleDownloadDraft = () => {
    const savedId = RCTI_ID || values.rctiID || values._id;
    if (savedId && draftDocument.canUseDocumentActions) {
      return downloadDraftPdf(savedId);
    }
    return handleSaveRCTI("downloadDraft");
  };

  const openDraftPreview = () => {
    const main = draftPreviewAnchorRef.current?.querySelector(
      ".invoice-flow-main"
    );
    const rect = main?.getBoundingClientRect();
    if (rect?.width)
      setDraftPreviewBounds({ left: rect.left, width: rect.width });
    setDraftPreviewOpen(true);
  };

  //Handle Save or Update RCTI Function
  const handleSaveRCTI = async (redirectToOutside = null, afterSaved = null) => {
    if (draftSaveRef.current || loading) return;
    values.expectedVersion = Number(values.version || 1);
    values.paymentOnly = Boolean(location.state?.paymentFlowReturn);
    if (
      (values.issuedAt || Number(values.emailSent) > 0) &&
      !location.state?.paymentFlowReturn
    ) {
      if (!String(values.adjustmentReason || "").trim()) {
        showResMsg(
          "Enter a reason to create an adjustment version.",
          2400,
          false
        );
        document.getElementById("rcti-adjustment-reason")?.focus();
        return;
      }
      values.expectedVersion = Number(values.version || 1);
    }
    if (values.supplierID && supplierEmailError) {
      setSupplierEmailValidationAttempted(true);
      window.requestAnimationFrame(() => {
        const input = document.getElementById("rcti-supplier-email");
        input?.focus({ preventScroll: true });
        input?.scrollIntoView({ behavior: "smooth", block: "center" });
      });
      return;
    }
    const savingDraftOnly =
    ["draft", "leaveAfterSave", "downloadDraft", "saveAndLeave"].includes(
      redirectToOutside
    ) &&
      !location.state?.paymentFlowReturn;
    if (savingDraftOnly) values.sendEmailFlag = false;
    if (
      draftDocument.canUseDocumentActions &&
      !values.issuedAt &&
      !Number(values.emailSent) &&
      !values.sendEmailFlag &&
      !fieldsVisible &&
      (!redirectToOutside || savingDraftOnly)
    ) {
      if (redirectToOutside === "downloadDraft") {
        return downloadDraftPdf(RCTI_ID || values.rctiID || values._id);
      }
      if (redirectToOutside === "leaveAfterSave") navigate("/rcti");
      else showDraftSavedMessage("Draft is already saved.");
      if (redirectToOutside === "saveAndLeave") unsavedChanges.markSaved();
      afterSaved?.();
      return;
    }
    draftSaveRef.current = true;
    setLoading(true);
    try {
      values.rctiNumber = String(values.rctiNumber || "").trim();

      type && (values.type = type);
      clearAllErrorMsg();
      values.itemsList = [];
      let mandateFlag = false;
      const adjustment = Boolean(
        values.issuedAt ||
          Number(values.emailSent) > 0 ||
          Number(values.version) > 1
      );
      try {
        values.supplyDate = validateRctiSupplyDate(
          values.originalSupplyDate && adjustment
            ? values.originalSupplyDate
            : values.supplyDate,
          new Date(),
          adjustment
        );
      } catch (error) {
        return showResMsg(error.message, 3000, false);
      }
      values.rctiDate = `${rctiToday()}T00:00:00.000Z`;
      values.dueDate = null;
      values.dueUpto = "";
      values.recurring = false;
      if (values.supplierID === "") {
        mandateFlag =
          validateField(values.supplierID, setContactNameErr) || mandateFlag;
        return;
      }

      if (
        values.gstType === "No GST" ||
        itemRowValues
          .filter(hasItemContent)
          .some((item) => Number(item.gst) <= 0)
      ) {
        return showResMsg(
          "Every RCTI line must be a taxable supply with a positive GST rate.",
          3000,
          false
        );
      }
      if (fieldsVisible && !savingDraftOnly) {
        mandateFlag =
          validateField(values.paymentMode, setPaymentModeErr) || mandateFlag;
        console.log("gg", values.paymentMode);
        if (values.paymentMode !== "Cash") {
          mandateFlag =
            validateField(
              values.paymentTransactionID,
              setPaymentTransactionIDErr
            ) || mandateFlag;
        }

        values.paymentAmount = values.finalAmount;
      } else {
        delete values.paymentMode;
        delete values.paymentTransactionID;
        delete values.paymentDate;
        delete values.paymentAmount;
      }

      if (RCTI_ID) {
        mandateFlag =
          validateField(values.rctiNumber, setInvoiceNoErr) || mandateFlag;

        const filterItemList = itemRowValues.filter(hasItemContent);

        if (filterItemList.length > 0) {
          const allRowsFilled = filterItemList.every(
            (row) =>
              hasItemIdentity(row) &&
              row.itemPrice &&
              row.itemQuantity &&
              row.categoryCodeName &&
              (row.discountType === "None" || row.discountValue !== "")
          );
          if (allRowsFilled) {
            values.itemsList = filterItemList;
          } else {
            return showResMsg(
              identifyMissingItems(filterItemList),
              2000,
              false
            );
          }
        } else {
          if (redirectToOutside === "redirectToItemWhenSave") {
            navigate(`/items/addItems?new=rcti&id=${RCTI_ID}`);
            return;
          } else {
            showResMsg("Please select at least 1 Item", 2000, false);
            return;
          }

          // navigate(`/items/addItems?new=rcti&id=${RCTI_ID}`);
          // return;
        }
      } else {
        const filterItemList = itemRowValues.filter(hasItemContent);

        if (filterItemList.length > 0) {
          const allRowsFilled = filterItemList.every(
            (row) =>
              hasItemIdentity(row) &&
              row.itemPrice &&
              row.itemQuantity &&
              row.categoryCodeName
          );
          if (allRowsFilled) {
            values.itemsList = filterItemList;
          } else {
            return showResMsg(
              identifyMissingItems(filterItemList),
              2000,
              false
            );
          }
        } else if (redirectToOutside === "redirectToItemWhenSave") {
          sessionStorage.setItem("HoldQuotationData", JSON.stringify(values));
          navigate(`/items/addItems?new=rcti`);
          return;
        }
        if (redirectToOutside === "redirectToEditItemWhenSave") {
          sessionStorage.setItem("HoldQuotationData", JSON.stringify(values));
          let ItemIdForItemEdit = sessionStorage.getItem("ItemIdForItemEdit");
          navigate(`/items/editItem/itemid=${ItemIdForItemEdit}?new=rcti`);
          return;
        } else {
          if (redirectToOutside === "redirectToItemWhenSave") {
            // values.itemsList = [];
            console.log("redirectToOutside", redirectToOutside);
          } else {
            if (!values.itemsList || values.itemsList.length === 0) {
              showResMsg("Please select at least 1 Item", 2000, false);
              return;
            }
          }

          // showResMsg("Please select at least 1 Item", 2000, false);
          // return;
        }
      }
      if (mandateFlag) return;
      values.itemsList = values.itemsList.map((row) => ({
        ...row,
        itemID: row.itemID || undefined,
        discountValue: row.discountType === "None" ? 0 : row.discountValue,
      }));
      values.currencyValue = rctiCurrencyCode(values.currencyValue, currencyCode);
      if (!/^[A-Z]{3}$/.test(values.currencyValue)) {
        showResMsg("Set a valid three-letter currency code in business settings before issuing this RCTI.", 3000, false);
        return;
      }

      if (redirectToOutside === "review") {
        await openIssueReview();
        return;
      }

      return await handleApiResponse({
        isUpdate: Boolean(RCTI_ID || values.rctiID),
        values,
        setOpen,
        showResMsg,
        navigate: (target, options) => {
          if (options?.state?.paymentError || options?.state?.rctiIssued) unsavedChanges.markSaved();
          navigate(target, options);
        },
        handleSoftDismisal,
        setShowBillingModal,
        dispatch,
        redirectToOutside,
        RCTI_ID,
        setCommunicationPhase,
        setCommunicationError,
        setValues,
        settlementReturn: Boolean(location.state?.paymentFlowReturn),
        saveAttachments,
        onDraftSaved: (savedValues) =>
          downloadDraftPdf(
            savedValues.rctiID || savedValues._id,
            savedValues.rctiNumber
          ),
        onSaved: (savedValues) => {
          numberValidation.clearError();
          draftDocument.markSaved(savedValues);
          setHasEditedRCTI(false);
          unsavedChanges.markSaved();
          afterSaved?.(savedValues);
        },
        onNumberError: (data) => {
          if (!numberValidation.handleResponse(data)) return false;
          setOpen(false);
          setCommunicationError("");
          setCommunicationPhase("review");
          setValues((current) => ({ ...current, sendEmailFlag: false }));
          return true;
        },
      });
    } finally {
      draftSaveRef.current = false;
      setLoading(false);
    }
  };
  saveAndExitRef.current = async () => {
    let saved = false;
    await handleSaveRCTI("saveAndExit", () => {
      saved = true;
    });
    return saved;
  };
  const handleCancelScreen = () => navigate("/rcti");
  const handleSoftDismisal = () => {
    ShowSwalWithButtons(
      `The Reference number already exists`,
      "Do you wish to continue?",
      "warning",
      darkMode,
      () => {
        values.skip_PO_NO = true;
        handleSaveRCTI();
      }
    );
  };

  //Handles Item Rows Functions
  const handleRemove = (index) => {
    ShowSwalWithButtons(
      "Are you sure?",
      `Would you like to remove the Item?`,
      "warning",
      darkMode,
      () => {
        setItemRowValues((currentRows) =>
          currentRows.length <= 1
            ? [{ ...EMPTY_ITEM_ROW }]
            : currentRows.filter((_, rowIndex) => rowIndex !== index)
        );
        setItemSearchQueries({});
        setActiveItemDropdownIdx(null);
      }
    );
  };

  const handleAddLineRow = () => {
    setActiveItemDropdownIdx(null);
    pendingItemsScrollRef.current = "bottom";
    setItemRowValues((previous) => [...previous, { ...EMPTY_ITEM_ROW }]);
  };

  const handleCalculation = (gstType, rows = itemRowValues) => {
    const { items, ...totals } = calculateRctiPricing(rows, gstType);
    setValues((previous) => ({ ...previous, ...totals, gstType }));
    setItemRowValues((previous) =>
      JSON.stringify(items) === JSON.stringify(previous) ? previous : items
    );
  };
  const calculateDiscountAmount = (rows) =>
    handleCalculation(values.gstType, rows);
  const handleItemRowChange = async (name, value, index) => {
    if (name === "itemQuantity") {
      value = sanitizeQuantityInputValue(value);
    } else if (value === ".") {
      value = "0.";
    }

    if (["itemPrice", "itemQuantity", "discountValue"].includes(name)) {
      if (value !== "" && !/^\d{0,7}(?:\.\d{0,2})?$/.test(String(value)))
        return;
      const row = itemRowValues[index];
      if (
        name === "discountValue" &&
        ((["Percentage", "%"].includes(row.discountType) &&
          Number(value) > 100) ||
          (row.discountType === "Fixed" &&
            Number(value) > Number(row.itemPrice) * Number(row.itemQuantity)))
      ) {
        showResMsg(
          "Discount cannot exceed the line amount or 100%",
          2000,
          false
        );
        return;
      }
    }
    const rows = itemRowValues.map((row, rowIndex) =>
      rowIndex === index
        ? {
            ...row,
            [name]: value,
            ...(name === "discountType" && value === "None"
              ? { discountValue: 0 }
              : {}),
          }
        : row
    );
    handleCalculation(values.gstType, rows);
  };

  const handleItemDescription = async (name, value, index) => {
    const updatedRows = [...itemRowValues];
    updatedRows[index] = { ...updatedRows[index], [name]: value };
    setItemRowValues(updatedRows);
  };

  const handleSelectCatalogueItem = (index, selectedItem) => {
    if (!selectedItem) return;
    setItemRowValues((previous) => {
      const updatedRows = [...previous];
      const itemPrice = parseFloat(selectedItem.itemPrice) || 0;
      const itemQuantity = parseFloat(updatedRows[index]?.itemQuantity) || 1;
      const discountType = selectedItem.discountType || "None";
      const discountValue =
        selectedItem.discountValue != null && selectedItem.discountValue !== ""
          ? String(selectedItem.discountValue)
          : "0";
      const gross = itemPrice * itemQuantity;
      const discountAmount =
        discountType === "Percentage"
          ? (gross * (parseFloat(discountValue) || 0)) / 100
          : discountType === "Fixed"
          ? parseFloat(discountValue) || 0
          : 0;
      updatedRows[index] = {
        ...updatedRows[index],
        itemID: selectedItem._id,
        itemName: selectedItem.itemName,
        itemDescription: selectedItem.itemDescription || "",
        categoryCodeName: selectedItem.categoryCodeName || "Sales",
        itemPrice,
        itemQuantity,
        gst: selectedItem.gst != null ? parseFloat(selectedItem.gst) : 10,
        discountType,
        discountValue,
        discountAmount,
        totalItemPrice: Math.max(0, gross - discountAmount).toFixed(2),
      };
      return updatedRows;
    });
    setItemSearchQueries((previous) => ({ ...previous, [index]: undefined }));
    setActiveItemDropdownIdx(null);
  };

  const handleItemRow = async (name, newValue, index) => {
    if (!newValue) {
      showResMsg("Please select an item", 1000, false);
      return;
    }
    if (newValue.value === "add-new") {
      handleAddNewItem();
    } else {
      const selectedItem = masterItemDetails.find(
        (item) => item._id === newValue.value
      );
      handleSelectCatalogueItem(index, selectedItem);
    }
  };

  useEffect(() => {
    const itemFromUrl = new URLSearchParams(window.location.search).get("item");

    console.log("itemFormUrl", itemFromUrl);
    if (itemFromUrl) {
      const selectedItem = masterItemDetails.find(
        (item) => item._id === itemFromUrl
      );
      console.log("selectedItem", selectedItem);
      console.log("itemRowValues", itemRowValues);
      const alreadyItemAdded = itemRowValues.some(
        (item) => item.itemID === itemFromUrl
      );
      console.log("alreadyItemAdded", alreadyItemAdded);
      // if (alreadyItemAdded) {

      //   console.log("Item already exists, skipping...");
      //   return;
      // }
      if (selectedItem) {
        console.log("selectedItem", selectedItem);
        const newItemValue = { value: itemFromUrl };

        // Find the first empty row (if any)
        const emptyRowIndex = itemRowValues.findIndex((row) => !row.value);

        if (emptyRowIndex) {
          // Update the first empty row found
          handleItemRow("", newItemValue, emptyRowIndex);
        } else {
          // If no empty row is found, update the last row or add new row logic
          const lastIndex = itemRowValues.length - 1;
          handleItemRow("", newItemValue, lastIndex);

          console.warn("No empty row found, updating the last row instead");
        }
      }
    }
  }, [masterItemDetails]);

  //RCTI Document Functions

  const updateUploadedDocuments = (uploaded, pendingID) => {
    setDocuments((current) => [
      ...uploaded,
      ...current.filter(
        (document) => document.file && document._id !== pendingID
      ),
    ]);
    setValues((current) => ({ ...current, documentName: "", selectedID: "" }));
  };

  const saveAttachments = async (rctiID) => {
    if (!quoDocuments.some((document) => document.file)) return true;
    setLoading(true);
    try {
      await uploadPendingAttachments(
        "rcti",
        rctiID,
        quoDocuments,
        updateUploadedDocuments
      );
      setFileError("");
      return true;
    } catch (error) {
      const message =
        "Draft saved, but " +
        error.message +
        " Save again to retry the attachment.";
      setFileError(message);
      showResMsg(message, 2500, false);
      return false;
    } finally {
      setLoading(false);
    }
  };

  const saveFile = async (event) => {
    const file = event.target.files?.[0];
    event.target.value = "";
    if (!file) return;
    if (file.size > 1 * 1024 * 1024) {
      setFileError("File size should be less than 1 MB");
      return;
    }
    setFileError("");
    const document = {
      ...createPendingAttachment(file),
      documentID: values.selectedID,
    };
    setDocuments((current) => [...current, document]);
    const rctiID = RCTI_ID || values.rctiID;
    if (!rctiID) return;
    setLoading(true);
    try {
      await uploadPendingAttachments(
        "rcti",
        rctiID,
        [document],
        updateUploadedDocuments
      );
      showResMsg("Attachment uploaded successfully.", 2000, true);
    } catch (error) {
      setFileError(
        error.response?.data?.Result_Message ||
          error.message ||
          "Attachment upload failed. Save again to retry."
      );
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteDocument = async (selectedDocRow) => {
    if (selectedDocRow.file) {
      setDocuments((current) =>
        current.filter((document) => document._id !== selectedDocRow._id)
      );
      setFileError("");
      return;
    }
    swal({
      title: "Are you sure?",
      text: `Would you like to delete "${selectedDocRow.documentName}" file?`,
      icon: "warning",
      color: "red",
      customClass: "swal-modal swal-title",
      closeOnClickOutside: false,
      closeOnEsc: false,
      buttons: {
        cancel: {
          text: "No",
          value: false,
          visible: true,
          className: "swalButtonStyle btn-warning no-button",
          closeModal: true,
        },
        confirm: {
          text: "Yes",
          value: true,
          visible: true,
          className: "swalButtonStyle btn-success yes-button",
          closeModal: true,
        },
      },
    }).then(async (value) => {
      if (value) {
        await axios
          .post(
            appConstants.baseURL + "invoice/deleteRCTIDocument",
            { documentID: selectedDocRow._id },
            {
              headers: {
                Authorization: `Bearer ${sessionStorage.getItem("TOKEN")}`,
              },
            }
          )
          .then((res) => {
            showResMsg(
              res.data.Result_Status
                ? "Document deleted successfully"
                : res.data.Result_Message,
              2000,
              res.data.Result_Status
            );
            if (res.data.Result_Status) {
              const updatedQuoDocument = quoDocuments.filter((doc) => {
                return doc._id !== selectedDocRow._id;
              });
              setDocuments(updatedQuoDocument);
            }
          })
          .catch((error) => {
            console.log("delete RCTI_Document error", error.message);
          });
      }
    });
  };
  const toggleFields = () => {
    if (fieldsVisible) {
      swal({
        title: "Would you like to Hide Payment Details?",
        text: `Hide Payment Details will not update the payment details.`,
        icon: "warning",
        color: "success",
        customClass: "swal-modal swal-title",
        closeOnClickOutside: false,
        closeOnEsc: false,
        buttons: {
          cancel: {
            text: "No",
            value: false,
            visible: true,
            className: "swalButtonStyle btn-warning no-button",
            closeModal: true,
          },
          confirm: {
            text: "Yes",
            value: true,
            visible: true,
            className: "swalButtonStyle btn-success yes-button",
            closeModal: true,
          },
        },
      }).then(async (value) => {
        if (value) {
          setFieldsVisible(!fieldsVisible);
        }
        swal.close();
      });
    } else {
      setFieldsVisible(!fieldsVisible);
    }
  };

  const handleSaveAndSendToEmail = async () => {
    if (itemRowValues.every((row) => !hasItemIdentity(row))) {
      Swal.fire({
        title: "Warning",
        text: "Please select the Item(s) before sending the email.",
        icon: "warning",
        confirmButtonText: "OK",
      });
    } else {
      ShowSwalWithButtons(
        "Are you sure?",
        `Would you like to send the RCTI (${values.rctiNumber}) via email to the Supplier Email Address?`,
        "question",
        darkMode,
        () => {
          values.sendEmailFlag = true;
          handleSaveRCTI();
        }
      );
      // Swal.fire({
      //   title: "Are you sure?",
      //   text: `Would you like to send the RCTI (${values.rctiNumber}) via email to the Supplier Email Address?`,
      //   icon: "question",
      //   showCancelButton: true,
      //   confirmButtonColor: "#4CAF50",
      //   cancelButtonColor: "#6c757d",
      //   confirmButtonText: "Yes",
      //   cancelButtonText: "No",
      //   reverseButtons: "true",
      //   reverseButtons: true,
      //   customClass: {
      //     title: darkMode ? 'swal-title-dark' : 'swal-title-light',
      //     popup: darkMode ? "darkPopup" : "whitePopup",
      //   }
      // }).then((result) => {
      //   if (result.isConfirmed) {
      //     values.sendEmailFlag = true;
      //     handleSaveRCTI();
      //   }
      // });
    }
  };

  const handleViewDocument = async (selectedDocRow) => {
    setSelectedFileType(selectedDocRow.fileType);
    if (selectedDocRow.file) {
      const url = URL.createObjectURL(selectedDocRow.file);
      if (["pdf", "image"].includes(selectedDocRow.fileType)) {
        setSetDocumentFileURL(url);
        setViewDocumentInModal(true);
      } else {
        const link = document.createElement("a");
        link.href = url;
        link.download = selectedDocRow.file.name;
        document.body.appendChild(link);
        link.click();
        link.remove();
        setTimeout(() => URL.revokeObjectURL(url), 30000);
      }
      return;
    }
    if (
      selectedDocRow.fileType === "pdf" ||
      selectedDocRow.fileType === "image"
    ) {
      try {
        const url = await rctiAttachmentUrl(selectedDocRow._id);
        setSetDocumentFileURL(url);
        setViewDocumentInModal(true);
      } catch {
        showResMsg(
          "The attachment could not be opened. Please sign in or retry.",
          3000,
          false
        );
      }
    } else {
      showResMsg("Document type not supported.", 2000, false);
    }
  };
  const handleCloseViewModal = () => {
    if (getDocumentFileURL.startsWith("blob:"))
      URL.revokeObjectURL(getDocumentFileURL);
    setSetDocumentFileURL("");
    setSelectedFileType("");
    setViewDocumentInModal(false);
  };
  useEffect(() => {
    if (!viewDocumentInModal) return undefined;
    const closeOnEscape = (event) => {
      if (event.key === "Escape") handleCloseViewModal();
    };
    document.addEventListener("keydown", closeOnEscape);
    return () => document.removeEventListener("keydown", closeOnEscape);
  }, [viewDocumentInModal]);
  useEffect(() => {
    if (!draftPreviewOpen) return undefined;
    const closeOnEscape = (event) => {
      if (event.key === "Escape") setDraftPreviewOpen(false);
    };
    document.addEventListener("keydown", closeOnEscape);
    return () => document.removeEventListener("keydown", closeOnEscape);
  }, [draftPreviewOpen]);
  //Modal Email Template used fxn start
  const handleEmailQuotation = () => {
    if (!buyerDeclarationConfirmed) {
      showResMsg("Confirm the buyer declaration before continuing.", 2500, false);
      return;
    }
    return handleSaveRCTI("review");
  };
  const openIssueReview = async () => {
    setCommunicationError("");
    setCommunicationPhase("loading");
    setOpen(true);
    if (AllKeysHaveValue(templateValues)) {
      setCommunicationPhase("review");
    } else {
      let received = false;
      await getEmailAndTemplateForQuotation(
        {
          screenType: templateValues.screenType,
          contactID: values.supplierID,
          selectedID: RCTI_ID,
          userID: String(
            sessionStorage.getItem("USER_ID") || loginDetails?._id || ""
          ).replaceAll('"', ""),
        },
        (data) => {
          received = true;
          if (data.Result_Status) {
            setTemplateValues(data.Result_Output);
            setCommunicationPhase("review");
            setOpen(true);
          } else {
            showResMsg("Please try again! Something went wrong");
            setOpen(false);
          }
        },
        dispatch
      );
      if (!received) {
        showResMsg("Could not prepare the supplier email. Please retry.", 2500, false);
        setOpen(false);
      }
    }
  };
  const handlePrepareStepClick = (stepIndex) => {
    if (!prepareReadyForReview || loading || ![1, 2].includes(stepIndex))
      return;
    communicationStartStepRef.current = stepIndex;
    handleSaveRCTI("review");
  };

  const handleClose = (event, reason) => {
    if (reason && reason === "backdropClick") return;
    setOpen(false);
  };
  const handleNavigateToEditorSection = (sectionId) => {
    setOpen(false);
    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        const section = document.getElementById(sectionId);
        if (!section) return;
        section.scrollIntoView({
          behavior: window.matchMedia?.("(prefers-reduced-motion: reduce)")
            .matches
            ? "auto"
            : "smooth",
          block: "start",
        });
        section.focus({ preventScroll: true });
      });
    });
  };
  const handleSend = (templateData) => {
    let payload = {
      userEmailAddress: templateData.userEmailAddress,
      customerEmailAddress: [...templateData.customerEmailAddress],
      emailTemplate: { ...templateData.emailTemplate },
    };
    values.sendEmailFlag = true;
    values.templateValues = payload;
    handleSaveRCTI();
  };

  // const handleRoute = () => {
  //   const contactFromUrl = new URLSearchParams(window.location.search).get('contact');
  //   if (contactFromUrl) {
  //     navigate(`/contacts/editContact/${contactFromUrl}`);
  //   }
  //   setOpenPop(false)
  // }

  // const handleRouteCancel = () => {
  //   setOpenPop(false)
  // }
  //Modal Email Template used fxn ends
  useEffect(() => {
    const contactFromUrl =
      (!RCTI_ID && location.state?.rctiSupplierID) ||
      new URLSearchParams(window.location.search).get("contact");
    console.log("contactFromUrl", contactFromUrl);
    if (contactFromUrl) {
      if (contactFromUrl === "add-new") {
        console.log("add-new");
        handleChangeCustomer("name")("", {
          label: "Add New ",
          value: "add-new",
        });
      } else {
        const selectedContact = contactDetails.find(
          (contact) => contact._id === contactFromUrl
        );
        console.log("selectedContact", selectedContact);
        if (selectedContact) {
          handleChangeCustomer("name")("", {
            label: selectedContact.companyName,
            value: contactFromUrl,
          });
        }
        // else {
        //   setOpenPop(true)
        // }
      }
    }
  }, [contactDetails]);

  const buyerDeclarationConfirmed =
    buyerDeclarationConfirmation ??
    (agreementData?.buyer?.isLargeBusiness === false &&
      agreementData?.buyer?.isGovernmentEntity === false);
  const supplierOptions = contactDetails.map((contact) => ({
    label: contact.companyName || contact.name,
    value: contact._id,
    disabled: contact.selectable === false,
    unavailableReason: contact.unavailableReason,
    email: contact.emailAddress || contact.email || "",
  }));

  if (values.supplierID && !supplierOptions.some((option) => String(option.value) === String(values.supplierID))) {
    const originalSupplier = agreementData?.contacts?.find((contact) => String(contact._id) === String(values.supplierID));
    supplierOptions.push({
      value: values.supplierID,
      label: originalSupplier?.companyName || originalSupplier?.name || "Original supplier (agreement required)",
      disabled: true,
      unavailableReason: "An active eligible agreement is required before saving or issuing.",
    });
  }

  const organisationName =
    loginDetails?.businessName ||
    loginDetails?.companyName ||
    loginDetails?.organisationName ||
    loginDetails?.organizationName ||
    loginDetails?.fullName ||
    loginDetails?.name ||
    [loginDetails?.firstName, loginDetails?.lastName]
      .filter(Boolean)
      .join(" ") ||
    "Invoice & Recover";
  const displayCurrencyCode = rctiCurrencyCode(values.currencyValue, currencyCode);
  const currentUserName = [loginDetails?.firstName, loginDetails?.lastName]
    .filter(Boolean)
    .join(" ");
  const supplierEmail =
    contactDetails.find((contact) => contact._id === values?.supplierID)
      ?.emailAddress || "";
  const supplierEmailError = !supplierEmail.trim()
    ? "Supplier email cannot be empty."
    : !validator.isEmail(supplierEmail.trim())
    ? "Please enter a valid email address, e.g. accounts@example.com."
    : "";
  const hasCalculatedRctiTotal = itemRowValues.some(
    (item) =>
      hasItemIdentity(item) &&
      Number(item.itemPrice) > 0 &&
      Number(item.itemQuantity) > 0
  );

  const activeAgreement = agreementData?.agreements?.find(
    (a) =>
      a.status === "active" &&
      String(a.contactID?._id || a.contactID) === String(values.supplierID)
  );
  const selectedSupplierIdentity = agreementData?.contacts?.find(
    (c) => String(c._id) === String(values.supplierID)
  );
  const prepareItems = itemRowValues.filter(hasItemContent);
  let supplyDateIsValid = true;
  try {
    validateRctiSupplyDate(values.supplyDate, new Date());
  } catch (error) {
    supplyDateIsValid = false;
  }
  const prepareReadyForReview = Boolean(
    !adjustmentOriginal &&
      values.supplierID &&
      selectedSupplierIdentity &&
      activeAgreement &&
      isSignedAgreement(activeAgreement) &&
      buyerDeclarationConfirmed &&
      !supplierEmailError &&
      !numberValidation.error &&
      supplyDateIsValid &&
      /^[A-Z]{3}$/.test(displayCurrencyCode) &&
      values.gstType !== "No GST" &&
      prepareItems.length > 0 &&
      prepareItems.every(
        (item) =>
          hasItemIdentity(item) &&
          Number(item.itemPrice) > 0 &&
          Number(item.itemQuantity) > 0 &&
          Number(item.gst) > 0 &&
          (item.discountType === "None" || item.discountValue !== "")
      )
  );
  const draftPreviewValues = {
    ...values,
    lifecycleStatus: "draft",
    issuedAt: null,
    emailSent: 0,
    buyerIdentity: agreementData?.buyer || {},
    supplierIdentity: selectedSupplierIdentity
      ? {
          ...selectedSupplierIdentity,
          name:
            selectedSupplierIdentity.companyName ||
            selectedSupplierIdentity.name,
        }
      : {},
    buyerAbn: agreementData?.buyer?.abnNumber || values.buyerAbn,
    supplierAbn: selectedSupplierIdentity?.abnNumber || values.supplierAbn,
  };
  const draftPreviewMoney = (amount) =>
    `${displayCurrencyCode} ${Number(amount || 0).toLocaleString("en-AU", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  const draftPreviewDate = (value) => {
    const date = value ? new Date(value) : null;
    return date && !Number.isNaN(date.getTime())
      ? new Intl.DateTimeFormat("en-AU", {
          day: "numeric",
          month: "short",
          year: "numeric",
          timeZone: "UTC",
        }).format(date)
      : "Not recorded";
  };
  return (
    <div
      ref={draftPreviewAnchorRef}
      className={`invoice-flow-shell rcti-editor-shell invoice-editor-shell${
        darkMode ? " dark" : ""
      }`}
    >
      {supplierEligibilityOpen && selectedSupplierIdentity && (
        <SupplierEligibilityDialog supplier={selectedSupplierIdentity} agreement={activeAgreement}
          darkMode={darkMode} onClose={() => setSupplierEligibilityOpen(false)} />
      )}
      <DashboardNavigation
        open={navOpen}
        onClose={() => setNavOpen(false)}
        activePath="/rcti"
        organisation={organisationName}
        role={loginDetails?.roleName || "Owner"}
      />
      <div className="invoice-flow-main">
        <AppHeader
          searchPlaceholder="Search RCTIs, suppliers, contacts"
          onOpenNav={() => setNavOpen(true)}
          userName={currentUserName}
        />
        <DebitNoteResponsiveHeader
          organisation={organisationName}
          role={loginDetails?.roleName || "Owner"}
        />
        <main
          className="invoice-editor-page rcti-prepare-page"
          onChangeCapture={() => setHasEditedRCTI(true)}
        >
          {initialLoading ? (
            <PageSkeleton type="editor" variant="document" label="Loading RCTI editor…" />
          ) : editorLoadError ? (
            <section className="invoice-flow-card" role="alert">
              <h1>RCTI editor unavailable</h1>
              <p>{editorLoadError}</p>
              <button type="button" className="rcti-detail-action" onClick={() => setLoadAttempt((attempt) => attempt + 1)}>Retry loading RCTI</button>
            </section>
          ) : (<>
          <div data-draft-save-confirmation />
          <button
            className="invoice-flow-back"
            type="button"
            onClick={handleCancelScreen}
          >
            <LuArrowLeft />
            Back to RCTIs
          </button>
          <header className="invoice-editor-header">
            <div>
              <h1>
                {adjustmentOriginal
                  ? "Create RCTI adjustment"
                  : "Prepare RCTI"}
              </h1>
              <p>
                <span>
                  {RCTI_ID || values.rctiID
                    ? values.rctiNumber || "Draft"
                    : "Unsaved"}
                </span>{" "}
                ·{" "}
                {adjustmentOriginal
                  ? `Correction of version ${adjustmentOriginal.version || 1}`
                  : "Internal reference only"}{" "}
                ·{" "}
                {draftDocument.canUseDocumentActions
                  ? "Saved draft"
                  : "Unsaved changes"}
              </p>
            </div>
          </header>

          <RctiSteps
            steps={
              adjustmentOriginal
                ? [
                    ["Create adjustment", "Reason & revised values"],
                    ["Review & issue", "Comparison & supplier email"],
                  ]
                : rctiSteps
            }
            current={0}
            enabledSteps={prepareReadyForReview ? [1, 2] : []}
            onStepClick={handlePrepareStepClick}
          />
          <div className="rcti-prepare-state">
            <div>
              <span className="rcti-status status-draft">
                {adjustmentOriginal
                  ? "Adjustment draft"
                  : "Draft · Not payable"}
              </span>
              <span>
                {adjustmentOriginal
                  ? "Issued history retained"
                  : "Not a tax invoice"}{" "}
                · {displayCurrencyCode}
              </span>
            </div>
          </div>
          {adjustmentOriginal && (
            <section className="invoice-flow-card rcti-adjustment-card">
              <h2>
                Create adjustment · Version {Number(values.version || 1) + (values.issuedAt || Number(values.emailSent) > 0 ? 1 : 0)}
              </h2>
              <p>
                Saving a correction preserves the issued version and updates
                this payable. It does not create a second liability.
              </p>
              <RCTIAdjustmentComparison
                original={adjustmentOriginal}
                revised={values}
                currencyCode={displayCurrencyCode}
              />
              <label htmlFor="rcti-adjustment-reason">Adjustment reason</label>
              <textarea
                id="rcti-adjustment-reason"
                maxLength={1000}
                value={values.adjustmentReason || ""}
                onChange={(event) =>
                  setValues((current) => ({
                    ...current,
                    adjustmentReason: event.target.value,
                  }))
                }
              />
            </section>
          )}
          {values.versions?.length > 0 && (
            <section className="invoice-flow-card rcti-adjustment-card">
              <h2>Previous versions</h2>
              {values.versions.map((revision) => (
                <section className="rcti-previous-version" key={revision.version}>
                  <h3>
                    Version {revision.version} · Invalidated by adjustment ·{" "}
                    {displayCurrencyCode}{" "}
                    {Number(revision.document?.finalAmount || 0).toFixed(2)}
                  </h3>
                  <p>
                    Adjustment: {revision.adjustmentReason} ·{" "}
                    {rctiTimestamp(revision.archivedAt)}
                  </p>
                  <p>
                    RCTI date: {rctiTimestamp(revision.document?.rctiDate)} ·
                    Supply:{" "}
                    {rctiCalendarDate(revision.document?.supplyDate) ||
                      "Not recorded"}
                  </p>
                  <ul>
                    {revision.items?.map((item, index) => (
                      <li key={index}>
                        {item.itemName || item.description} ·{" "}
                        {item.itemQuantity} × {item.itemPrice}
                      </li>
                    ))}
                  </ul>
                </section>
              ))}
            </section>
          )}
          <div className="invoice-editor-grid">
            <div className="invoice-editor-column">
              <section
                id="rcti-prepare-parties"
                tabIndex={-1}
                className="invoice-flow-card rcti-prepare-parties"
              >
                <h2>Supplier and agreement</h2>
                {new URLSearchParams(location.search).has("cloneFrom") && values.supplierID && !contactDetails.some((contact) => String(contact._id) === String(values.supplierID) && contact.selectable !== false) && (
                  <p role="status" className="rcti-communication-validation">
                    The original supplier has been retained. An active eligible agreement is required before saving or issuing. Restore that supplier’s agreement or choose another eligible supplier.
                  </p>
                )}
                {!contactDetails.some((contact) => contact.selectable !== false) && (
                  <p role="status">
                    No contacts with an active agreement.{" "}
                    <Link to="/rcti-agreements">Set up an RCTI agreement</Link>{" "}
                    before creating an RCTI.
                  </p>
                )}
                <div className="invoice-fields two">
                  <label>
                    Supplier
                    <InvoiceSelect
                      disabled={Boolean(
                        values.issuedAt ||
                          Number(values.emailSent) > 0 ||
                          values.versions?.length
                      )}
                      contactType="supplier"
                      className="rcti-supplier-select"
                      dark={darkMode}
                      aria-label="Supplier"
                      aria-invalid={contactNameErr}
                      value={values.supplierID || ""}
                      onChange={(event) => {
                        if (event.target.value === "add-new") {
                          navigate("/rcti-agreements/new");
                          return;
                        }
                        const option = supplierOptions.find(
                          (supplier) =>
                            String(supplier.value) ===
                            String(event.target.value)
                        );
                        handleChangeCustomer("name")(event, option || null);
                      }}
                    >
                      <option value="" hidden>
                        Select a supplier
                      </option>
                      <option value="add-new">Create New RCTI Agreement</option>
                      {supplierOptions.map((supplier) => (
                        <option
                          key={supplier.value}
                          value={supplier.value}
                          disabled={supplier.disabled}
                          data-description={[supplier.email, supplier.unavailableReason].filter(Boolean).join(" · ")}
                        >
                          {supplier.label}
                        </option>
                      ))}
                    </InvoiceSelect>
                    {contactNameErr && (
                      <span className="quotation-field-error" role="alert">
                        Please select a supplier.
                      </span>
                    )}
                  </label>
                  <div className="rcti-prepare-agreement">
                    <label>
                      Current signed agreement
                      <input
                        readOnly
                        value={
                          activeAgreement
                            ? `AGR-${String(activeAgreement._id)
                                .slice(-8)
                                .toUpperCase()} · v${
                                activeAgreement.version
                              } · Active`
                            : "Select an eligible supplier"
                        }
                      />
                    </label>
                    {activeAgreement && (
                      <>
                        <span className="rcti-status status-paid">
                          Active · Signed agreement
                        </span>
                        <p>
                          Accepted v{activeAgreement.version} ·{" "}
                          {rctiTimestamp(activeAgreement.supplierSignedAt)}
                        </p>
                        <p>{activeAgreement.scope}</p>
                        <Link to={`/rcti-agreements/${activeAgreement._id}`}>
                          View agreement
                        </Link>
                      </>
                    )}
                  </div>
                </div>
                {values.supplierID && (
                  <div className="rcti-prepare-contact">
                    <strong>
                      {selectedSupplierIdentity?.companyName ||
                        selectedSupplierIdentity?.name}
                    </strong>
                    <span>
                      ABN {formatAbn(selectedSupplierIdentity?.abnNumber)}
                    </span>
                    <p>
                      {selectedSupplierIdentity?.name} · {supplierEmail}
                    </p>
                    <p className="rcti-prepare-address">{contactAddress(selectedSupplierIdentity)}</p>
                    <Link to={`/contacts/${values.supplierID}`}>
                      View supplier contact
                    </Link>
                  </div>
                )}
                {values.supplierID &&
                  supplierEmailValidationAttempted &&
                  supplierEmailError && (
                    <p
                      id="rcti-supplier-email"
                      tabIndex={-1}
                      role="alert"
                      className="quotation-field-error"
                    >
                      {supplierEmailError}
                    </p>
                  )}
                <p className="rcti-prepare-buyer">
                  Buyer / issuer: {organisationName} · ABN{" "}
                  {formatAbn(agreementData?.buyer?.abnNumber)}
                  {currentUserName ? ` · ${currentUserName}` : ""}
                </p>
                <div
                  id="rcti-buyer-declaration"
                  tabIndex={-1}
                  className="rcti-prepare-declaration"
                >
                  <label className="rcti-prepare-declaration-check">
                    <input type="checkbox" checked={buyerDeclarationConfirmed} onChange={(event)=>setBuyerDeclarationConfirmation(event.target.checked)} />
                    <span>Buyer declares it is not a large business or government entity for this supported pathway.</span>
                  </label>
                  <button type="button" className="rcti-business-eligibility-action"
                    disabled={!selectedSupplierIdentity}
                    onClick={() => setSupplierEligibilityOpen(true)}>
                    View business eligibility
                  </button>
                </div>
              </section>
              <section
                id="rcti-prepare-dates"
                tabIndex={-1}
                className="invoice-flow-card rcti-prepare-dates"
              >
                <h2>Dates</h2>
                <div className="invoice-fields two invoice-date-fields">
                  <label>
                    Issue date (today)
                    <input type="date" value={rctiToday()} readOnly />
                  </label>
                  <div className="invoice-date-picker-field">
                    <PickDate
                      id="rcti-supply-date"
                      label="Supply date"
                      required
                      toggleCalendarOnIconClick
                      selected={
                        rctiCalendarDate(values.supplyDate)
                          ? new Date(
                              `${rctiCalendarDate(values.supplyDate)}T00:00:00`
                            )
                          : null
                      }
                      minDate={
                        values.issuedAt ||
                        Number(values.emailSent) > 0 ||
                        Number(values.version) > 1
                          ? undefined
                          : new Date(`${rctiEarliestSupplyDate()}T00:00:00`)
                      }
                      maxDate={new Date(`${rctiToday()}T00:00:00`)}
                      readOnly={Boolean(
                        values.originalSupplyDate &&
                          (values.issuedAt ||
                            Number(values.emailSent) > 0 ||
                            Number(values.version) > 1)
                      )}
                      onChange={(date) => {
                        setHasEditedRCTI(true);
                        setValues((current) => ({
                          ...current,
                          supplyDate: date ? format(date, "yyyy-MM-dd") : "",
                        }));
                      }}
                    />
                  </div>
                </div>
                <small>
                  Select a supply date from today back to 28 days ago,
                  inclusive. Dates use Australia/Sydney. Issued RCTIs do not
                  expire. Adjustments keep the original supply date.
                </small>
                <section className="rcti-prepare-reference">
                  <h3>Reference and draft numbering</h3>
                  <label>
                    Job / project / PO reference
                    <input
                      value={values.purchaseOrderNumber || ""}
                      onChange={handleChange("purchaseOrderNumber")}
                      placeholder="Add a reference"
                      maxLength={50}
                    />
                  </label>
                  <label>
                    RCTI number
                    <input
                      id="rcti-number-input"
                      value={values.rctiNumber || ""}
                      aria-invalid={Boolean(
                        invoiceNoErr || numberValidation.error
                      )}
                      aria-describedby={
                        invoiceNoErr || numberValidation.error
                          ? "rcti-number-error"
                          : undefined
                      }
                      placeholder={
                        rctiNumber.loading
                          ? "Loading RCTI number..."
                          : "RCTI number"
                      }
                      maxLength={100}
                      disabled={
                        loading ||
                        Boolean(
                          values.issuedAt ||
                            Number(values.emailSent) > 0 ||
                            values.versions?.length
                        )
                      }
                      onChange={(event) => {
                        setInvoiceNoErr(false);
                        numberValidation.clearError();
                        rctiNumber.onChange(event);
                      }}
                    />
                    {(invoiceNoErr || numberValidation.error) && (
                      <span
                        id="rcti-number-error"
                        className="quotation-field-error"
                        role="alert"
                      >
                        {numberValidation.error ||
                          "Please enter an RCTI number"}
                      </span>
                    )}
                  </label>
                </section>
              </section>

              <section
                id="rcti-prepare-line-items"
                tabIndex={-1}
                className="invoice-flow-card invoice-items-editor"
              >
                <div className="invoice-section-title">
                  <div>
                    <h2>Taxable line items</h2>
                    <p>
                      {values.gstType === "No GST"
                        ? "No GST applies to this document."
                        : values.gstType === "Exclusive"
                        ? "GST is added to the line totals."
                        : "Unit prices and line totals include GST."}
                    </p>
                  </div>
                  <InvoiceSelect
                    dark={darkMode}
                    aria-label="GST pricing basis"
                    value={values.gstType || "Inclusive"}
                    onChange={handleChange("gstType")}
                  >
                    <option value="Inclusive">GST inclusive</option>
                    <option value="Exclusive">GST exclusive</option>
                  </InvoiceSelect>
                </div>
                <div className="invoice-item-heading">
                  <span>Description</span>
                  <span>Qty</span>
                  <span>Unit price</span>
                  <span>GST</span>
                  <span>Line total</span>
                  <span />
                </div>
                <div
                  ref={itemsTableBodyRef}
                  className={`quotation-items-table-body${
                    itemRowValues.length > MAX_VISIBLE_ITEM_ROWS
                      ? " is-scrollable"
                      : ""
                  }`}
                  style={
                    itemsViewportHeight
                      ? { maxHeight: `${itemsViewportHeight}px` }
                      : undefined
                  }
                  data-line-item-list="rcti"
                  tabIndex={
                    itemRowValues.length > MAX_VISIBLE_ITEM_ROWS ? 0 : undefined
                  }
                  aria-label="RCTI items"
                >
                  {itemRowValues.map((row, index) => {
                    const query = (itemSearchQueries[index] ?? "")
                      .trim()
                      .toLowerCase();
                    const catalogueMatches = masterItemDetails.filter(
                      (item) =>
                        !query ||
                        [item.itemName, item.itemCode, item.itemDescription]
                          .filter(Boolean)
                          .some((field) => field.toLowerCase().includes(query))
                    );
                    const itemTotal = calculateRctiPricing(
                      [row],
                      values.gstType
                    ).items[0].totalItemPrice;
                    return (
                      <div
                        {...itemReorder.getRowProps(index, "invoice-edit-item")}
                        key={index}
                      >
                        <div
                          className="quotation-item-search-row item-picker"
                          ref={(element) => {
                            itemDropdownRefs.current[index] = element;
                          }}
                        >
                          <div className="quotation-item-search-box">
                            <button {...itemReorder.getHandleProps(index)}>
                              <LuGripVertical />
                            </button>
                            <LuSearch />
                            <ClearableSearchInput
                              id={`rcti-item-search-${index}`}
                              role="combobox"
                              aria-label={`Search item for line ${index + 1}`}
                              aria-expanded={activeItemDropdownIdx === index}
                              aria-controls={
                                activeItemDropdownIdx === index
                                  ? `rcti-item-results-${index}`
                                  : undefined
                              }
                              aria-autocomplete="list"
                              placeholder="Search catalogue item e.g. Safety upgrade"
                              value={
                                activeItemDropdownIdx === index
                                  ? itemSearchQueries[index] ??
                                    row.itemName ??
                                    ""
                                  : row.itemName || ""
                              }
                              onChange={(event) => {
                                const queryValue = event.target.value;
                                setItemSearchQueries((previous) => ({
                                  ...previous,
                                  [index]: queryValue,
                                }));
                                handleItemDescription(
                                  "itemName",
                                  queryValue,
                                  index
                                );
                                setActiveItemDropdownIdx(index);
                              }}
                              onFocus={() => setActiveItemDropdownIdx(index)}
                              onKeyDown={(event) => {
                                if (event.key === "Escape")
                                  setActiveItemDropdownIdx(null);
                              }}
                            />
                            <button
                              type="button"
                              className="quotation-item-search-toggle"
                              aria-haspopup="listbox"
                              aria-expanded={activeItemDropdownIdx === index}
                              aria-label={`${
                                activeItemDropdownIdx === index
                                  ? "Close"
                                  : "Open"
                              } catalogue item options`}
                              onClick={() =>
                                setActiveItemDropdownIdx(
                                  activeItemDropdownIdx === index ? null : index
                                )
                              }
                            >
                              <LuChevronDown />
                            </button>
                          </div>
                          {activeItemDropdownIdx === index && (
                            <CatalogueItemDropdown
                              anchorEl={itemDropdownRefs.current[index]}
                              onClose={() => setActiveItemDropdownIdx(null)}
                            >
                              <div
                                id={`rcti-item-results-${index}`}
                                className="quotation-item-search-results-list"
                                role="listbox"
                                aria-label="Catalogue items"
                              >
                                <button
                                  type="button"
                                  role="option"
                                  aria-selected={false}
                                  className="quotation-item-result-card quotation-new-item-option"
                                  onClick={() => {
                                    setItemModalTargetIdx(index);
                                    setActiveItemDropdownIdx(null);
                                    setItemModalError("");
                                    resetNewItemForm(
                                      itemSearchQueries[index] ||
                                        row.itemName ||
                                        ""
                                    );
                                    setIsItemModalOpen(true);
                                  }}
                                >
                                  <div className="quotation-item-result-top">
                                    <div className="quotation-item-result-name-group">
                                      <LuPlus className="quotation-match-icon" />
                                      <span className="quotation-item-result-name">
                                        Add new item
                                      </span>
                                    </div>
                                  </div>
                                  <p className="quotation-item-result-sub">
                                    Add this item to your catalogue
                                  </p>
                                </button>
                                {catalogueMatches.map((item) => {
                                  const selected =
                                    row.itemID === item._id ||
                                    (Boolean(row.itemName) &&
                                      row.itemName === item.itemName);
                                  return (
                                    <button
                                      type="button"
                                      role="option"
                                      aria-selected={selected}
                                      key={item._id}
                                      className="quotation-autocomplete-item quotation-catalogue-option"
                                      onClick={() =>
                                        handleSelectCatalogueItem(index, item)
                                      }
                                    >
                                      <strong>
                                        {item.itemName || item.itemDescription}
                                      </strong>
                                      <span>
                                        {[
                                          item.itemCode,
                                          item.itemDescription || item.itemName,
                                          `GST ${displayCurrencyCode} ${formatCurrencyAUD(
                                            item.itemPrice || 0
                                          )}`,
                                        ]
                                          .filter(Boolean)
                                          .join(" · ")}
                                      </span>
                                    </button>
                                  );
                                })}
                                {catalogueMatches.length === 0 && (
                                  <div className="quotation-item-no-results">
                                    <strong>No matching catalogue items</strong>
                                    <span>
                                      Add this as a new item to save it for
                                      future RCTIs.
                                    </span>
                                  </div>
                                )}
                              </div>
                            </CatalogueItemDropdown>
                          )}
                        </div>
                        <input
                          className="item-description"
                          aria-label={`Description for line ${index + 1}`}
                          value={row.itemDescription || ""}
                          onChange={(event) =>
                            handleItemDescription(
                              "itemDescription",
                              event.target.value,
                              index
                            )
                          }
                          placeholder="Add a description"
                        />
                        <input
                          aria-label={`Quantity for line ${index + 1}`}
                          inputMode="numeric"
                          pattern="[0-9]*"
                          maxLength={4}
                          value={row.itemQuantity ?? ""}
                          onChange={(event) =>
                            handleItemRowChange(
                              "itemQuantity",
                              event.target.value,
                              index
                            )
                          }
                          placeholder="Qty"
                        />
                        <input
                          aria-label={`Unit price for line ${index + 1}`}
                          inputMode="decimal"
                          value={
                            row.itemPrice === ""
                              ? ""
                              : formatNumberWithCommas(row.itemPrice)
                          }
                          onChange={(event) =>
                            handleItemRowChange(
                              "itemPrice",
                              event.target.value.replace(/,/g, ""),
                              index
                            )
                          }
                          placeholder="Unit price"
                        />
                        <InvoiceSelect
                          dark={darkMode}
                          className="rcti-line-tax"
                          aria-label={`GST for line ${index + 1}`}
                          disabled={values.gstType === "No GST"}
                          value={
                            values.gstType === "No GST" ? 0 : row.gst ?? 10
                          }
                          onChange={(event) =>
                            handleItemRowChange(
                              "gst",
                              event.target.value,
                              index
                            )
                          }
                        >
                          {row.gst !== undefined &&
                            row.gst !== "" &&
                            ![0, 10].includes(Number(row.gst)) && (
                              <option value={row.gst}>{row.gst}%</option>
                            )}
                          {Number(row.gst) === 0 && (
                            <option value="0" disabled>
                              0% — select taxable GST
                            </option>
                          )}
                          <option value="10">10%</option>
                        </InvoiceSelect>
                        <strong>
                          {displayCurrencyCode} {formatCurrencyAUD(itemTotal)}
                        </strong>
                        <div className="invoice-rcti-row-actions">
                          {(index > 0 || hasItemContent(row)) && (
                            <button
                              type="button"
                              aria-label={`Remove line ${index + 1}`}
                              title="Remove line"
                              onClick={() => handleRemove(index)}
                            >
                              <LuTrash2 />
                            </button>
                          )}
                        </div>
                        <div className="rcti-line-discounts">
                          <label>
                            Discount type{" "}
                            <InvoiceSelect
                              dark={darkMode}
                              aria-label={`Discount type for line ${index + 1}`}
                              className="discount-type"
                              value={row.discountType || "None"}
                              onChange={(event) =>
                                handleItemRowChange(
                                  "discountType",
                                  event.target.value,
                                  index
                                )
                              }
                            >
                              <option value="None">No discount</option>
                              <option value="Percentage">Percentage</option>
                              <option value="Fixed">Fixed amount</option>
                            </InvoiceSelect>
                          </label>
                          <label>
                            Discount value
                            <input
                              className="discount-value"
                              aria-label={`Discount value for line ${
                                index + 1
                              }`}
                              inputMode="decimal"
                              value={row.discountValue || ""}
                              disabled={
                                !row.discountType || row.discountType === "None"
                              }
                              onChange={(event) =>
                                handleItemRowChange(
                                  "discountValue",
                                  event.target.value,
                                  index
                                )
                              }
                              placeholder="Discount value"
                            />
                          </label>
                        </div>
                      </div>
                    );
                  })}
                </div>
                <div className="invoice-item-actions">
                  <button type="button" onClick={handleAddLineRow}>
                    <LuPlus />
                    Add line
                  </button>
                  <button type="button" onClick={handleAddNewItem}>
                    <LuPlus />
                    New catalogue item
                  </button>
                </div>
                <small>
                  Amounts are calculated from line items, GST treatment and
                  discounts.
                </small>
              </section>

              <div className="invoice-flow-card rcti-prepare-notes">
                <h2>Notes and attachments</h2>
                <section className="rcti-prepare-notes-fields">
                  <p>These details appear on the supplier’s RCTI.</p>
                  <div className="invoice-fields invoice-notes-fields">
                    <label>
                      Notes to supplier
                      <textarea
                        value={values.supplierNotes || ""}
                        onChange={handleChange("supplierNotes")}
                        placeholder="Add scope or supplier-facing notes"
                        maxLength={500}
                      />
                    </label>
                    <section className="rcti-prepare-extra-note">
                      <h3>Additional RCTI note</h3>
                      <label>
                        RCTI notes
                        <textarea
                          value={values.rctiNotes || ""}
                          onChange={handleChange("rctiNotes")}
                          placeholder="Add an RCTI note "
                          maxLength={500}
                        />
                      </label>
                    </section>
                  </div>
                </section>

                <section
                  className="invoice-flow-card quotation-attachments-card"
                  aria-labelledby="rcti-attachments-heading"
                >
                  <h2 id="rcti-attachments-heading">Attachments</h2>
                  {loading && !draftSaveRef.current && (
                    <div role="status" aria-busy="true" aria-label="Uploading RCTI attachment…">
                      <Skeleton width="100%" height={40} radius={10} />
                      <span className="skeleton-sr-only">Uploading RCTI attachment…</span>
                    </div>
                  )}
                  <div className="quotation-attachment-summary">
                    <strong>
                      {quoDocuments.length
                        ? quoDocuments.length + " attachment(s)"
                        : "No attachments added"}
                    </strong>
                    <p>Optional supporting files. The RCTI PDF is separate.</p>
                  </div>
                  {quoDocuments.length > 0 && (
                    <div className="quotation-attachments-list">
                      {quoDocuments.map((document) => (
                        <div
                          key={document._id}
                          className="quotation-attachment-item"
                        >
                          <span className="quotation-attachment-info">
                            <LuFileText aria-hidden="true" />
                            <span>
                              {document.documentName}
                              {document.file && " (pending save)"}
                            </span>
                          </span>
                          <div className="quotation-attachment-actions">
                            <button
                              type="button"
                              className="quotation-attachment-view-btn"
                              onClick={() =>
                                !document.file &&
                                ["docx", "doc", "excel"].includes(
                                  document.fileType
                                )
                                  ? downloadRctiAttachment(document)
                                  : handleViewDocument(document)
                              }
                              aria-label={"View " + document.documentName}
                              title="View document"
                            >
                              <LuEye aria-hidden="true" />
                            </button>
                            <button
                              type="button"
                              className="quotation-attachment-remove-btn"
                              aria-label={"Remove " + document.documentName}
                              title="Delete document"
                              disabled={loading || SCREEN_RIGHT === "View Only"}
                              onClick={() => handleDeleteDocument(document)}
                            >
                              <LuTrash2 aria-hidden="true" />
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                  <label className="quotation-attachment-upload">
                    <LuUpload aria-hidden="true" />
                    Add attachment
                    <input
                      id="rctiDocuments"
                      type="file"
                      disabled={loading || SCREEN_RIGHT === "View Only"}
                      onChange={saveFile}
                    />
                  </label>
                  {fileError && (
                    <small className="quotation-attachment-error" role="alert">
                      {fileError}
                    </small>
                  )}
                </section>
              </div>

              <section className="invoice-flow-card rcti-editor-settlement">
                <h2>Settlement information</h2>
                <div className="invoice-fields">
                  <label>
                    Settlement information
                    <textarea
                      value={values.paymentInstruction || ""}
                      onChange={handleChange("paymentInstruction")}
                      placeholder="No settlement information configured"
                      maxLength={100}
                    />
                  </label>
                </div>
                <small>
                  Optional instructions appear on the supplier’s RCTI.
                </small>
              </section>

              {RCTI_ID && showInvoicePaymentLink && (
                <section className="invoice-flow-card">
                  <div className="invoice-section-title">
                    <div>
                      <h2>Settlement details</h2>
                      <p>Payment details for this RCTI.</p>
                    </div>
                    <button type="button" className="rcti-detail-action" onClick={toggleFields}
                      aria-expanded={fieldsVisible} aria-controls="rcti-settlement-details">
                      {fieldsVisible
                        ? "Hide details"
                        : values?.rctiStatus === "Paid"
                        ? "View details"
                        : "Update details"}
                    </button>
                  </div>
                  {fieldsVisible && (
                    <div className="invoice-fields two" id="rcti-settlement-details">
                      <label>
                        Payment date
                        <input
                          value={values.paymentDate && !Number.isNaN(new Date(values.paymentDate).getTime())
                            ? format(new Date(values.paymentDate), "d MMM yyyy")
                            : "Not recorded"}
                          readOnly
                        />
                      </label>
                      <label>
                        Payment mode
                        <InvoiceSelect
                          dark={darkMode}
                          aria-label="Payment mode"
                          value={values.paymentMode || ""}
                          onChange={handleChange("paymentMode")}
                        >
                          <option value="">Select payment mode</option>
                          {[
                            "Cash",
                            "Paypal",
                            "Card",
                            "Cheque",
                            "Bank Transfer",
                            "Wire Transfer",
                          ].map((mode) => (
                            <option key={mode} value={mode}>
                              {mode}
                            </option>
                          ))}
                        </InvoiceSelect>
                      </label>
                      <label>
                        Transaction ID
                        <input
                          value={values.paymentTransactionID || ""}
                          onChange={handleChange("paymentTransactionID")}
                          disabled={values.paymentMode === "Cash"}
                        />
                      </label>
                      <label>
                        Payment amount ({displayCurrencyCode})
                        <input
                          value={formatCurrencyAUD(
                            parseFloat(values.finalAmount).toFixed(2)
                          )}
                          readOnly
                        />
                      </label>
                    </div>
                  )}
                </section>
              )}
            </div>

            <aside className="invoice-editor-aside rcti-prepare-total">
              <section className="invoice-flow-card invoice-summary-card">
                <h2>{adjustmentOriginal ? "Adjustment total" : "Draft total"}</h2>
                {!hasCalculatedRctiTotal && <p>Not yet calculated</p>}
                <p>
                  <span>Subtotal excluding GST</span>
                  <strong>
                    {hasCalculatedRctiTotal
                      ? formatCurrencyAUD(values.totalAmount || 0)
                      : "—"}
                  </strong>
                </p>
                <p>
                  <span>
                    {values.gstType === "No GST"
                      ? "Discounts"
                      : "Discounts (GST inclusive)"}
                  </span>
                  <strong>
                    {hasCalculatedRctiTotal
                      ? formatCurrencyAUD(values.totalDiscountAmount || 0)
                      : "—"}
                  </strong>
                </p>
                <p>
                  <span>{values.gstType === "No GST" ? "No GST" : "GST"}</span>
                  <strong>
                    {hasCalculatedRctiTotal
                      ? formatCurrencyAUD(values.totalGSTAmount || 0)
                      : "—"}
                  </strong>
                </p>
                <hr />
                <p className="grand">
                  <span>Total {displayCurrencyCode}</span>
                  <strong>
                    {hasCalculatedRctiTotal
                      ? formatCurrencyAUD(values.finalAmount || 0)
                      : "—"}
                  </strong>
                </p>
                <small>
                  {values.gstType === "No GST"
                    ? "No GST applies. Discounts already appear on line items."
                    : "GST is included in the total. Discounts already appear on line items."}
                </small>
                {!values.issuedAt && !Number(values.emailSent) && (
                  <div className="rcti-draft-total-actions">
                    <button
                      type="button"
                      className="rcti-detail-action"
                      onClick={openDraftPreview}
                    >
                      <LuEye aria-hidden="true" />
                      Draft Preview
                    </button>
                    <button
                      type="button"
                      className="rcti-detail-action primary"
                      disabled={loading || downloadingDraft}
                      onClick={handleDownloadDraft}
                    >
                      <LuFileText aria-hidden="true" />
                      {downloadingDraft ? "Preparing PDF…" : "Download draft"}
                    </button>
                  </div>
                )}
              </section>
              <p>{adjustmentOriginal ? "Revised values for this payable. Issued history is retained." : "Not a tax invoice. This draft creates no payable."}</p>
            </aside>
          </div>
          <footer className="rcti-editor-footer">
            <button type="button" onClick={handleCancelScreen}>
              ← Back to RCTIs
            </button>
            <div>
              <button
                type="button"
                disabled={loading}
                onClick={() => handleSaveRCTI("leaveAfterSave")}
              >
                {adjustmentOriginal ? "Save adjustment" : "Save Draft"}
              </button>
              <button
                className="primary"
                type="button"
                disabled={loading || !showSendEmailBtn || !buyerDeclarationConfirmed}
                onClick={handleEmailQuotation}
              >
                {adjustmentOriginal ? "Review adjustment" : "Continue to eligibility review"}
              </button>
            </div>
          </footer>
          </>)}
        </main>
      </div>
      {draftPreviewOpen && (
        <div
          className="rcti-invoice-preview-backdrop"
          style={{
            top: 0,
            ...(draftPreviewBounds
              ? {
                  left: draftPreviewBounds.left,
                  width: draftPreviewBounds.width,
                }
              : {}),
          }}
          role="presentation"
          onMouseDown={(event) => {
            if (event.target === event.currentTarget)
              setDraftPreviewOpen(false);
          }}
        >
          <section
            className="rcti-invoice-preview-dialog"
            role="dialog"
            aria-modal="true"
            aria-labelledby="rcti-draft-preview-title"
          >
            <header>
              <div>
                <h2 id="rcti-draft-preview-title">Draft Preview</h2>
                <p>{values.rctiNumber || "New RCTI draft"} · Not issued</p>
              </div>
              <button
                type="button"
                aria-label="Close draft preview"
                onClick={() => setDraftPreviewOpen(false)}
              >
                <LuX aria-hidden="true" />
              </button>
            </header>
            <div className="rcti-invoice-preview-document">
              <RCTIDocument
                values={draftPreviewValues}
                items={itemRowValues.filter(hasItemIdentity)}
                documents={[]}
                showAttachments={false}
                organisation={organisationName}
                rctiID={values.rctiID || RCTI_ID || "draft-preview"}
                loadingPage={false}
                currencyCode={displayCurrencyCode}
                subtotalExcludingGst={Number(values.totalAmount || 0)}
                gstSummaryLabel={
                  values.gstType === "Exclusive" ? "GST" : "GST (included)"
                }
                total={Number(values.finalAmount || 0)}
                money={draftPreviewMoney}
                dateValue={draftPreviewDate}
                agreement={activeAgreement}
              />
            </div>
          </section>
        </div>
      )}
      {viewDocumentInModal && (
        <div
          className="quotation-dialog-scrim document-preview-overlay"
          data-clickable="true"
          onClick={handleCloseViewModal}
        >
          <div
            className="quotation-document-preview"
            role="dialog"
            aria-modal="true"
            aria-label="Attachment preview"
            data-clickable={false}
            onClick={(event) => event.stopPropagation()}
          >
            <button
              type="button"
              className="quotation-document-preview-close"
              aria-label="Close document preview"
              onClick={handleCloseViewModal}
            >
              <LuX />
            </button>
            {selectedFileType === "image" ? (
              <img src={getDocumentFileURL} alt="Attachment Preview" />
            ) : selectedFileType === "pdf" ? (
              <iframe
                title="Document Preview"
                className="quotation-document-preview-pdf"
                src={`${getDocumentFileURL}#toolbar=0&navpanes=0&view=FitH`}
              />
            ) : null}
          </div>
        </div>
      )}
      {showBillingModal && (
        <BillingModal
          open={showBillingModal}
          handleConfirm={() => {
            navigate("/subscriptions");
          }}
          handleCancel={() => {
            setShowBillingModal(false);
          }}
          closeModalClick={() => {
            setShowBillingModal(false);
          }}
          message={genericMessage.billingMsg}
          title={genericMessage.noCreditAvailableTitle}
        />
      )}
      {isItemModalOpen && (
        <CatalogueItemModal
          portalDropdowns
          darkMode={darkMode}
          isSaving={isItemSaving}
          onClose={itemModalChanges.requestClose}
        >
          <div
            className="quotation-modal-dialog quotation-catalogue-modal"
            role="dialog"
            aria-modal="true"
            aria-label="Add new catalogue item"
            onClick={(event) => event.stopPropagation()}
          >
            <div className="quotation-modal-header">
              <h3>Add new item</h3>
              <button
                type="button"
                className="quotation-dialog-close-btn"
                disabled={isItemSaving}
                onClick={itemModalChanges.requestClose}
                aria-label="Close"
              >
                <LuX />
              </button>
            </div>

            <div className="quotation-modal-body">
              {itemModalError &&
                !["itemCode", "itemName", "itemPrice"].includes(
                  itemModalError
                ) && (
                  <div className="quotation-modal-alert" role="alert">
                    <LuCircleAlert />
                    <span>{itemModalError}</span>
                  </div>
                )}

              <div className="quotation-catalogue-row quotation-catalogue-row-three">
                <div className="quotation-field-wrap">
                  <label>
                    Item code <span className="quotation-required-star">*</span>
                  </label>
                  <div
                    className={`quotation-input-box${
                      itemModalError === "itemCode"
                        ? " quotation-input-error"
                        : ""
                    }`}
                  >
                    <input
                      placeholder="e.g. SRV-011"
                      value={newItemForm.itemCode}
                      onChange={(event) => {
                        const itemCode = event.target.value;
                        setNewItemForm((prev) => ({
                          ...prev,
                          itemCode,
                        }));
                        if (itemModalError === "itemCode" && itemCode.trim())
                          setItemModalError("");
                      }}
                    />
                  </div>
                  {itemModalError === "itemCode" && (
                    <small className="quotation-field-error">
                      Enter an item code.
                    </small>
                  )}
                </div>
                <div className="quotation-field-wrap">
                  <label>
                    Item name <span className="quotation-required-star">*</span>
                  </label>
                  <div
                    className={`quotation-input-box${
                      itemModalError === "itemName"
                        ? " quotation-input-error"
                        : ""
                    }`}
                  >
                    <input
                      value={newItemForm.itemName}
                      onChange={(event) => {
                        const itemName = event.target.value;
                        setNewItemForm((prev) => ({
                          ...prev,
                          itemName,
                        }));
                        if (itemModalError === "itemName" && itemName.trim())
                          setItemModalError("");
                      }}
                      autoFocus
                    />
                  </div>
                  {itemModalError === "itemName" && (
                    <small className="quotation-field-error">
                      Enter an item name.
                    </small>
                  )}
                </div>
                <div className="quotation-field-wrap">
                  <label>Account</label>
                  <InvoiceSelect
                    dark={darkMode}
                    aria-label="Account"
                    value={newItemForm.categoryCodeName}
                    onChange={(event) =>
                      setNewItemForm((prev) => ({
                        ...prev,
                        categoryCodeName: event.target.value,
                      }))
                    }
                  >
                    {catalogueAccountOptions.map((account) => (
                      <option key={account.value} value={account.value}>
                        {account.label}
                      </option>
                    ))}
                  </InvoiceSelect>
                </div>
              </div>

              <div className="quotation-catalogue-row quotation-catalogue-row-two">
                <div className="quotation-field-wrap">
                  <label>Description</label>
                  <div className="quotation-input-box">
                    <input
                      value={newItemForm.itemDescription}
                      onChange={(event) =>
                        setNewItemForm((prev) => ({
                          ...prev,
                          itemDescription: event.target.value,
                        }))
                      }
                    />
                  </div>
                </div>
                <div className="quotation-field-wrap">
                  <label>Status</label>
                  <InvoiceSelect
                    dark={darkMode}
                    aria-label="Status"
                    value={newItemForm.status}
                    onChange={(event) =>
                      setNewItemForm((prev) => ({
                        ...prev,
                        status: event.target.value,
                      }))
                    }
                  >
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                  </InvoiceSelect>
                </div>
              </div>

              <div className="quotation-catalogue-row quotation-catalogue-row-three">
                <div className="quotation-field-wrap">
                  <label className="quotation-optional-label">
                    Unit · optional
                  </label>
                  <InvoiceSelect
                    dark={darkMode}
                    aria-label="Unit"
                    value={newItemForm.unit}
                    onChange={(event) =>
                      setNewItemForm((prev) => ({
                        ...prev,
                        unit: event.target.value,
                      }))
                    }
                  >
                    {["each", "hour", "day", "item"].map((unit) => (
                      <option key={unit} value={unit}>
                        {unit}
                      </option>
                    ))}
                  </InvoiceSelect>
                </div>
                <div className="quotation-field-wrap">
                  <label>
                    Unit price{" "}
                    <span className="quotation-required-star">*</span>
                  </label>
                  <div
                    className={`quotation-input-box quotation-money-input${
                      itemModalError === "itemPrice"
                        ? " quotation-input-error"
                        : ""
                    }`}
                  >
                    <span>$</span>
                    <input
                      type="number"
                      min="0"
                      step="0.01"
                      placeholder="0.00"
                      value={newItemForm.itemPrice}
                      onKeyDown={(event) =>
                        ["e", "E", "+", "-"].includes(event.key) &&
                        event.preventDefault()
                      }
                      onChange={(event) => {
                        const itemPrice = event.target.value;
                        setNewItemForm((prev) => ({
                          ...prev,
                          itemPrice,
                        }));
                        if (itemModalError === "itemPrice" && itemPrice !== "")
                          setItemModalError("");
                      }}
                    />
                  </div>
                  {itemModalError === "itemPrice" && (
                    <small className="quotation-field-error">
                      Enter a unit price.
                    </small>
                  )}
                </div>
                <div className="quotation-field-wrap">
                  <label>Default quantity</label>
                  <div className="quotation-input-box">
                    <input
                      type="number"
                      min="0"
                      step="1"
                      value={newItemForm.defaultQuantity}
                      onKeyDown={(event) =>
                        ["e", "E", "+", "-"].includes(event.key) &&
                        event.preventDefault()
                      }
                      onChange={(event) =>
                        setNewItemForm((prev) => ({
                          ...prev,
                          defaultQuantity: event.target.value,
                        }))
                      }
                    />
                  </div>
                </div>
              </div>

              <div className="quotation-catalogue-row quotation-catalogue-row-three">
                <div className="quotation-field-wrap">
                  <label>GST</label>
                  <InvoiceSelect
                    dark={darkMode}
                    aria-label="GST"
                    value={newItemForm.gst}
                    onChange={(event) =>
                      setNewItemForm((prev) => ({
                        ...prev,
                        gst: event.target.value,
                      }))
                    }
                  >
                    <option value={10}>10%</option>
                    <option value={0}>0%</option>
                  </InvoiceSelect>
                </div>
                <div className="quotation-field-wrap">
                  <label>Default discount</label>
                  <InvoiceSelect
                    dark={darkMode}
                    aria-label="Default discount"
                    value={newItemForm.discountType}
                    onChange={(event) =>
                      setNewItemForm((prev) => ({
                        ...prev,
                        discountType: event.target.value,
                        discountValue:
                          event.target.value === "None"
                            ? ""
                            : prev.discountValue,
                      }))
                    }
                  >
                    <option value="None">None</option>
                    <option value="Percentage">Percentage</option>
                    <option value="Fixed">Fixed amount</option>
                  </InvoiceSelect>
                </div>
                <div
                  className={`quotation-field-wrap${
                    newItemForm.discountType === "None"
                      ? " quotation-field-disabled"
                      : ""
                  }`}
                >
                  <label>Discount value</label>
                  <div className="quotation-input-box">
                    <input
                      type="number"
                      min="0"
                      disabled={newItemForm.discountType === "None"}
                      value={newItemForm.discountValue}
                      onKeyDown={(event) =>
                        ["e", "E", "+", "-"].includes(event.key) &&
                        event.preventDefault()
                      }
                      onChange={(event) =>
                        setNewItemForm((prev) => ({
                          ...prev,
                          discountValue: event.target.value,
                        }))
                      }
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="quotation-modal-footer">
              <button
                type="button"
                className="quotation-modal-cancel-btn"
                disabled={isItemSaving}
                onClick={itemModalChanges.requestClose}
              >
                Cancel
              </button>
              <button
                type="button"
                className="quotation-modal-submit-btn"
                onClick={handleQuickCreateItem}
                disabled={isItemSaving}
              >
                {isItemSaving ? "Saving..." : "Save & add to RCTI"}
              </button>
            </div>
          </div>
          {itemModalChanges.dialog}
        </CatalogueItemModal>
      )}
      <RCTIIssueCommunications
        open={open}
        dark={darkMode}
        phase={communicationPhase}
        errorMessage={communicationError}
        values={{
          ...values,
          supplierEmail: supplierEmail || values.supplierEmail,
          buyerAbn: agreementData?.buyer?.abnNumber,
          supplierAbn: selectedSupplierIdentity?.abnNumber,
          supplierCompanyName:
            selectedSupplierIdentity?.companyName ||
            selectedSupplierIdentity?.name,
          rctiAgreementID: activeAgreement?._id || values.rctiAgreementID,
        }}
        organisationName={organisationName}
        currencyCode={displayCurrencyCode}
        amountPaid={values.paymentAmount || 0}
        outstandingAmount={values.finalAmount || 0}
        appliedAdjustments={
          values.adjustedAmount || values.appliedCreditAmount || 0
        }
        previewItems={itemRowValues.filter(hasItemIdentity)}
        templatesData={templateValues}
        agreement={activeAgreement}
        buyer={agreementData?.buyer}
        supplier={selectedSupplierIdentity}
        adjustmentOriginal={adjustmentOriginal}
        initialReviewStep={communicationStartStepRef.current}
        onClose={handleClose}
        onNavigateTo={handleNavigateToEditorSection}
        onSubmit={handleSend}
        onViewDetails={() => {
          setOpen(false);
          const targetId = RCTI_ID || values.rctiID;
          if (targetId) navigate(`/rcti/view/${targetId}`);
        }}
      />

      {/* {openPop && (
        <RouteModal
          open={openPop}
          handleRoute={handleRoute}
          handleCancel={() => handleRouteCancel("handleRouteCancel")}
          closeModalClick={() => handleRouteCancel("closeModalClick")}
          heading={"Please Send the Email for Verify the Supplier by Editing"}
        />
      )} */}
      {unsavedChanges.dialog}
    </div>
  );
}

export default RCTI;
